export const COUNTRIES = {
  BR: {
    states: [
      { name: "Acre", code: "BR-AC", minZip: 0, maxZip: 999999 },
      { name: "Alagoas", code: "BR-AL", minZip: 0, maxZip: 999999 },
      { name: "Amapá", code: "BR-AP", minZip: 0, maxZip: 999999 },
      { name: "Amazonas", code: "BR-AM", minZip: 0, maxZip: 999999 },
      { name: "Bahia", code: "BR-BA", minZip: 0, maxZip: 999999 },
      { name: "Ceará", code: "BR-CE", minZip: 0, maxZip: 999999 },
      { name: "Distrito Federal", code: "BR-DF", minZip: 0, maxZip: 999999 },
      { name: "Espírito Santo", code: "BR-ES", minZip: 0, maxZip: 999999 },
      { name: "Goiás", code: "BR-GO", minZip: 0, maxZip: 999999 },
      { name: "Maranhão", code: "BR-MA", minZip: 0, maxZip: 999999 },
      { name: "Mato Grosso", code: "BR-MT", minZip: 0, maxZip: 999999 },
      {
        name: "Mato Grosso do Sul",
        code: "BR-MS",
        minZip: 0,
        maxZip: 999999,
      },
      { name: "Minas Gerais", code: "BR-MG", minZip: 0, maxZip: 999999 },
      { name: "Pará", code: "BR-PA", minZip: 0, maxZip: 999999 },
      { name: "Paraíba", code: "BR-PB", minZip: 0, maxZip: 999999 },
      { name: "Paraná", code: "BR-PR", minZip: 0, maxZip: 999999 },
      { name: "Pernambuco", code: "BR-PE", minZip: 0, maxZip: 999999 },
      { name: "Piauí", code: "BR-PI", minZip: 0, maxZip: 999999 },
      { name: "Rio de Janeiro", code: "BR-RJ", minZip: 0, maxZip: 999999 },
      {
        name: "Rio Grande do Norte",
        code: "BR-RN",
        minZip: 0,
        maxZip: 999999,
      },
      {
        name: "Rio Grande do Sul",
        code: "BR-RS",
        minZip: 0,
        maxZip: 999999,
      },
      { name: "Rondônia", code: "BR-RO", minZip: 0, maxZip: 999999 },
      { name: "Roraima", code: "BR-RR", minZip: 0, maxZip: 999999 },
      { name: "Santa Catarina", code: "BR-SC", minZip: 0, maxZip: 999999 },
      { name: "São Paulo", code: "BR-SP", minZip: 0, maxZip: 999999 },
      { name: "Sergipe", code: "BR-SE", minZip: 0, maxZip: 999999 },
      { name: "Tocantins", code: "BR-TO", minZip: 0, maxZip: 999999 },
    ],
    cities: [
      { name: "Rio Branco", state: "Acre" },
      { name: "Maceió", state: "Alagoas" },
      { name: "Arapiraca", state: "Alagoas" },
      { name: "Macapá", state: "Amapá" },
      { name: "Santana", state: "Amapá" },
      { name: "Manaus", state: "Amazonas" },
      { name: "Itacoatiara", state: "Amazonas" },
      { name: "Manacapuru", state: "Amazonas" },
      { name: "Salvador", state: "Bahia" },
      { name: "Feira de Santana", state: "Bahia" },
      { name: "Vitória da Conquista", state: "Bahia" },
      { name: "Camaçari", state: "Bahia" },
      { name: "Juazeiro", state: "Bahia" },
      { name: "Lauro de Freitas", state: "Bahia" },
      { name: "Itabuna", state: "Bahia" },
      { name: "Ilhéus", state: "Bahia" },
      { name: "Porto Seguro", state: "Bahia" },
      { name: "Barreiras", state: "Bahia" },
      { name: "Jequié", state: "Bahia" },
      { name: "Alagoinhas", state: "Bahia" },
      { name: "Teixeira de Freitas", state: "Bahia" },
      { name: "Simões Filho", state: "Bahia" },
      { name: "Eunápolis", state: "Bahia" },
      { name: "Paulo Afonso", state: "Bahia" },
      { name: "Luís Eduardo Magalhães", state: "Bahia" },
      { name: "Santo Antônio de Jesus", state: "Bahia" },
      { name: "Fortaleza", state: "Ceará" },
      { name: "Caucaia", state: "Ceará" },
      { name: "Juazeiro do Norte", state: "Ceará" },
      { name: "Maracanaú", state: "Ceará" },
      { name: "Sobral", state: "Ceará" },
      { name: "Itapipoca", state: "Ceará" },
      { name: "Crato", state: "Ceará" },
      { name: "Maranguape", state: "Ceará" },
      { name: "Brasília", state: "Distrito Federal" },
      { name: "Serra", state: "Espírito Santo" },
      { name: "Vila Velha", state: "Espírito Santo" },
      { name: "Cariacica", state: "Espírito Santo" },
      { name: "Vitória", state: "Espírito Santo" },
      { name: "Cachoeiro de Itapemirim", state: "Espírito Santo" },
      { name: "Linhares", state: "Espírito Santo" },
      { name: "Guarapari", state: "Espírito Santo" },
      { name: "São Mateus", state: "Espírito Santo" },
      { name: "Colatina", state: "Espírito Santo" },
      { name: "Goiânia", state: "Goiás" },
      { name: "Aparecida de Goiânia", state: "Goiás" },
      { name: "Anápolis", state: "Goiás" },
      { name: "Rio Verde", state: "Goiás" },
      { name: "Águas Lindas de Goiás", state: "Goiás" },
      { name: "Luziânia", state: "Goiás" },
      { name: "Valparaíso de Goiás", state: "Goiás" },
      { name: "Senador Canedo", state: "Goiás" },
      { name: "Trindade", state: "Goiás" },
      { name: "Formosa", state: "Goiás" },
      { name: "Catalão", state: "Goiás" },
      { name: "Itumbiara", state: "Goiás" },
      { name: "Jataí", state: "Goiás" },
      { name: "Planaltina", state: "Goiás" },
      { name: "Novo Gama", state: "Goiás" },
      { name: "São Luís", state: "Maranhão" },
      { name: "Imperatriz", state: "Maranhão" },
      { name: "São José de Ribamar", state: "Maranhão" },
      { name: "Timon", state: "Maranhão" },
      { name: "Caxias", state: "Maranhão" },
      { name: "Paço do Lumiar", state: "Maranhão" },
      { name: "Codó", state: "Maranhão" },
      { name: "Açailândia", state: "Maranhão" },
      { name: "Bacabal", state: "Maranhão" },
      { name: "Balsas", state: "Maranhão" },
      { name: "Cuiabá", state: "Mato Grosso" },
      { name: "Várzea Grande", state: "Mato Grosso" },
      { name: "Rondonópolis", state: "Mato Grosso" },
      { name: "Sinop", state: "Mato Grosso" },
      { name: "Sorriso", state: "Mato Grosso" },
      { name: "Tangará da Serra", state: "Mato Grosso" },
      { name: "Campo Grande", state: "Mato Grosso do Sul" },
      { name: "Dourados", state: "Mato Grosso do Sul" },
      { name: "Três Lagoas", state: "Mato Grosso do Sul" },
      { name: "Belo Horizonte", state: "Minas Gerais" },
      { name: "Uberlândia", state: "Minas Gerais" },
      { name: "Contagem", state: "Minas Gerais" },
      { name: "Juiz de Fora", state: "Minas Gerais" },
      { name: "Montes Claros", state: "Minas Gerais" },
      { name: "Betim", state: "Minas Gerais" },
      { name: "Uberaba", state: "Minas Gerais" },
      { name: "Ribeirão das Neves", state: "Minas Gerais" },
      { name: "Governador Valadares", state: "Minas Gerais" },
      { name: "Divinópolis", state: "Minas Gerais" },
      { name: "Ipatinga", state: "Minas Gerais" },
      { name: "Sete Lagoas", state: "Minas Gerais" },
      { name: "Santa Luzia", state: "Minas Gerais" },
      { name: "Ibirité", state: "Minas Gerais" },
      { name: "Poços de Caldas", state: "Minas Gerais" },
      { name: "Patos de Minas", state: "Minas Gerais" },
      { name: "Pouso Alegre", state: "Minas Gerais" },
      { name: "Teófilo Otoni", state: "Minas Gerais" },
      { name: "Varginha", state: "Minas Gerais" },
      { name: "Conselheiro Lafaiete", state: "Minas Gerais" },
      { name: "Sabará", state: "Minas Gerais" },
      { name: "Vespasiano", state: "Minas Gerais" },
      { name: "Barbacena", state: "Minas Gerais" },
      { name: "Araguari", state: "Minas Gerais" },
      { name: "Itabira", state: "Minas Gerais" },
      { name: "Passos", state: "Minas Gerais" },
      { name: "Nova Lima", state: "Minas Gerais" },
      { name: "Araxá", state: "Minas Gerais" },
      { name: "Nova Serrana", state: "Minas Gerais" },
      { name: "Lavras", state: "Minas Gerais" },
      { name: "Coronel Fabriciano", state: "Minas Gerais" },
      { name: "Muriaé", state: "Minas Gerais" },
      { name: "Ubá", state: "Minas Gerais" },
      { name: "Ituiutaba", state: "Minas Gerais" },
      { name: "Belém", state: "Pará" },
      { name: "Ananindeua", state: "Pará" },
      { name: "Santarém", state: "Pará" },
      { name: "Marabá", state: "Pará" },
      { name: "Parauapebas", state: "Pará" },
      { name: "Castanhal", state: "Pará" },
      { name: "Abaetetuba", state: "Pará" },
      { name: "Cametá", state: "Pará" },
      { name: "Barcarena", state: "Pará" },
      { name: "Altamira", state: "Pará" },
      { name: "Itaituba", state: "Pará" },
      { name: "Bragança", state: "Pará" },
      { name: "Marituba", state: "Pará" },
      { name: "Breves", state: "Pará" },
      { name: "Paragominas", state: "Pará" },
      { name: "João Pessoa", state: "Paraíba" },
      { name: "Campina Grande", state: "Paraíba" },
      { name: "Santa Rita", state: "Paraíba" },
      { name: "Patos", state: "Paraíba" },
      { name: "Curitiba", state: "Paraná" },
      { name: "Londrina", state: "Paraná" },
      { name: "Maringá", state: "Paraná" },
      { name: "Ponta Grossa", state: "Paraná" },
      { name: "Cascavel", state: "Paraná" },
      { name: "São José dos Pinhais", state: "Paraná" },
      { name: "Foz do Iguaçu", state: "Paraná" },
      { name: "Colombo", state: "Paraná" },
      { name: "Guarapuava", state: "Paraná" },
      { name: "Araucária", state: "Paraná" },
      { name: "Toledo", state: "Paraná" },
      { name: "Fazenda Rio Grande", state: "Paraná" },
      { name: "Paranaguá", state: "Paraná" },
      { name: "Campo Largo", state: "Paraná" },
      { name: "Apucarana", state: "Paraná" },
      { name: "Pinhais", state: "Paraná" },
      { name: "Almirante Tamandaré", state: "Paraná" },
      { name: "Arapongas", state: "Paraná" },
      { name: "Piraquara", state: "Paraná" },
      { name: "Sarandi", state: "Paraná" },
      { name: "Umuarama", state: "Paraná" },
      { name: "Cambé", state: "Paraná" },
      { name: "Recife", state: "Pernambuco" },
      { name: "Jaboatão dos Guararapes", state: "Pernambuco" },
      { name: "Petrolina", state: "Pernambuco" },
      { name: "Caruaru", state: "Pernambuco" },
      { name: "Olinda", state: "Pernambuco" },
      { name: "Paulista", state: "Pernambuco" },
      { name: "Cabo de Santo Agostinho", state: "Pernambuco" },
      { name: "Camaragibe", state: "Pernambuco" },
      { name: "Garanhuns", state: "Pernambuco" },
      { name: "Vitória de Santo Antão", state: "Pernambuco" },
      { name: "Igarassu", state: "Pernambuco" },
      { name: "São Lourenço da Mata", state: "Pernambuco" },
      { name: "Teresina", state: "Piauí" },
      { name: "Parnaíba", state: "Piauí" },
      { name: "Rio de Janeiro", state: "Rio de Janeiro" },
      { name: "São Gonçalo", state: "Rio de Janeiro" },
      { name: "Duque de Caxias", state: "Rio de Janeiro" },
      { name: "Nova Iguaçu", state: "Rio de Janeiro" },
      { name: "Campos dos Goytacazes", state: "Rio de Janeiro" },
      { name: "Belford Roxo", state: "Rio de Janeiro" },
      { name: "Niterói", state: "Rio de Janeiro" },
      { name: "São João de Meriti", state: "Rio de Janeiro" },
      { name: "Petrópolis", state: "Rio de Janeiro" },
      { name: "Volta Redonda", state: "Rio de Janeiro" },
      { name: "Macaé", state: "Rio de Janeiro" },
      { name: "Magé", state: "Rio de Janeiro" },
      { name: "Itaboraí", state: "Rio de Janeiro" },
      { name: "Cabo Frio", state: "Rio de Janeiro" },
      { name: "Maricá", state: "Rio de Janeiro" },
      { name: "Nova Friburgo", state: "Rio de Janeiro" },
      { name: "Barra Mansa", state: "Rio de Janeiro" },
      { name: "Angra dos Reis", state: "Rio de Janeiro" },
      { name: "Mesquita", state: "Rio de Janeiro" },
      { name: "Teresópolis", state: "Rio de Janeiro" },
      { name: "Rio das Ostras", state: "Rio de Janeiro" },
      { name: "Nilópolis", state: "Rio de Janeiro" },
      { name: "Queimados", state: "Rio de Janeiro" },
      { name: "Araruama", state: "Rio de Janeiro" },
      { name: "Resende", state: "Rio de Janeiro" },
      { name: "Itaguaí", state: "Rio de Janeiro" },
      { name: "São Pedro da Aldeia", state: "Rio de Janeiro" },
      { name: "Itaperuna", state: "Rio de Janeiro" },
      { name: "Natal", state: "Rio Grande do Norte" },
      { name: "Mossoró", state: "Rio Grande do Norte" },
      { name: "Parnamirim", state: "Rio Grande do Norte" },
      { name: "São Gonçalo do Amarante", state: "Rio Grande do Norte" },
      { name: "Porto Alegre", state: "Rio Grande do Sul" },
      { name: "Caxias do Sul", state: "Rio Grande do Sul" },
      { name: "Canoas", state: "Rio Grande do Sul" },
      { name: "Pelotas", state: "Rio Grande do Sul" },
      { name: "Santa Maria", state: "Rio Grande do Sul" },
      { name: "Gravataí", state: "Rio Grande do Sul" },
      { name: "Novo Hamburgo", state: "Rio Grande do Sul" },
      { name: "Viamão", state: "Rio Grande do Sul" },
      { name: "São Leopoldo", state: "Rio Grande do Sul" },
      { name: "Passo Fundo", state: "Rio Grande do Sul" },
      { name: "Rio Grande", state: "Rio Grande do Sul" },
      { name: "Alvorada", state: "Rio Grande do Sul" },
      { name: "Cachoeirinha", state: "Rio Grande do Sul" },
      { name: "Santa Cruz do Sul", state: "Rio Grande do Sul" },
      { name: "Sapucaia do Sul", state: "Rio Grande do Sul" },
      { name: "Bento Gonçalves", state: "Rio Grande do Sul" },
      { name: "Bagé", state: "Rio Grande do Sul" },
      { name: "Uruguaiana", state: "Rio Grande do Sul" },
      { name: "Erechim", state: "Rio Grande do Sul" },
      { name: "Porto Velho", state: "Rondônia" },
      { name: "Ji-Paraná", state: "Rondônia" },
      { name: "Boa Vista", state: "Roraima" },
      { name: "Joinville", state: "Santa Catarina" },
      { name: "Florianópolis", state: "Santa Catarina" },
      { name: "Blumenau", state: "Santa Catarina" },
      { name: "São José", state: "Santa Catarina" },
      { name: "Itajaí", state: "Santa Catarina" },
      { name: "Chapecó", state: "Santa Catarina" },
      { name: "Palhoça", state: "Santa Catarina" },
      { name: "Criciúma", state: "Santa Catarina" },
      { name: "Jaraguá do Sul", state: "Santa Catarina" },
      { name: "Lages", state: "Santa Catarina" },
      { name: "Brusque", state: "Santa Catarina" },
      { name: "Balneário Camboriú", state: "Santa Catarina" },
      { name: "Tubarão", state: "Santa Catarina" },
      { name: "Camboriú", state: "Santa Catarina" },
      { name: "São Paulo", state: "São Paulo" },
      { name: "Guarulhos", state: "São Paulo" },
      { name: "Campinas", state: "São Paulo" },
      { name: "São Bernardo do Campo", state: "São Paulo" },
      { name: "Santo André", state: "São Paulo" },
      { name: "Osasco", state: "São Paulo" },
      { name: "Sorocaba", state: "São Paulo" },
      { name: "Ribeirão Preto", state: "São Paulo" },
      { name: "São José dos Campos", state: "São Paulo" },
      { name: "São José do Rio Preto", state: "São Paulo" },
      { name: "Mogi das Cruzes", state: "São Paulo" },
      { name: "Jundiaí", state: "São Paulo" },
      { name: "Piracicaba", state: "São Paulo" },
      { name: "Santos", state: "São Paulo" },
      { name: "Mauá", state: "São Paulo" },
      { name: "Diadema", state: "São Paulo" },
      { name: "Carapicuíba", state: "São Paulo" },
      { name: "Bauru", state: "São Paulo" },
      { name: "Itaquaquecetuba", state: "São Paulo" },
      { name: "Franca", state: "São Paulo" },
      { name: "Praia Grande", state: "São Paulo" },
      { name: "São Vicente", state: "São Paulo" },
      { name: "Barueri", state: "São Paulo" },
      { name: "Taubaté", state: "São Paulo" },
      { name: "Suzano", state: "São Paulo" },
      { name: "Limeira", state: "São Paulo" },
      { name: "Guarujá", state: "São Paulo" },
      { name: "Sumaré", state: "São Paulo" },
      { name: "Cotia", state: "São Paulo" },
      { name: "Taboão da Serra", state: "São Paulo" },
      { name: "Indaiatuba", state: "São Paulo" },
      { name: "São Carlos", state: "São Paulo" },
      { name: "Embu das Artes", state: "São Paulo" },
      { name: "Araraquara", state: "São Paulo" },
      { name: "Jacareí", state: "São Paulo" },
      { name: "Marília", state: "São Paulo" },
      { name: "Americana", state: "São Paulo" },
      { name: "Hortolândia", state: "São Paulo" },
      { name: "Itapevi", state: "São Paulo" },
      { name: "Presidente Prudente", state: "São Paulo" },
      { name: "Rio Claro", state: "São Paulo" },
      { name: "Araçatuba", state: "São Paulo" },
      { name: "Santa Bárbara d'Oeste", state: "São Paulo" },
      { name: "Ferraz de Vasconcelos", state: "São Paulo" },
      { name: "Bragança Paulista", state: "São Paulo" },
      { name: "Itu", state: "São Paulo" },
      { name: "São Caetano do Sul", state: "São Paulo" },
      { name: "Pindamonhangaba", state: "São Paulo" },
      { name: "Francisco Morato", state: "São Paulo" },
      { name: "Atibaia", state: "São Paulo" },
      { name: "Itapecerica da Serra", state: "São Paulo" },
      { name: "Itapetininga", state: "São Paulo" },
      { name: "Santana de Parnaíba", state: "São Paulo" },
      { name: "Mogi Guaçu", state: "São Paulo" },
      { name: "Botucatu", state: "São Paulo" },
      { name: "Franco da Rocha", state: "São Paulo" },
      { name: "Caraguatatuba", state: "São Paulo" },
      { name: "Salto", state: "São Paulo" },
      { name: "Jaú", state: "São Paulo" },
      { name: "Araras", state: "São Paulo" },
      { name: "Votorantim", state: "São Paulo" },
      { name: "Sertãozinho", state: "São Paulo" },
      { name: "Valinhos", state: "São Paulo" },
      { name: "Tatuí", state: "São Paulo" },
      { name: "Barretos", state: "São Paulo" },
      { name: "Itatiba", state: "São Paulo" },
      { name: "Birigui", state: "São Paulo" },
      { name: "Jandira", state: "São Paulo" },
      { name: "Guaratinguetá", state: "São Paulo" },
      { name: "Catanduva", state: "São Paulo" },
      { name: "Várzea Paulista", state: "São Paulo" },
      { name: "Ribeirão Pires", state: "São Paulo" },
      { name: "Itanhaém", state: "São Paulo" },
      { name: "Cubatão", state: "São Paulo" },
      { name: "Paulínia", state: "São Paulo" },
      { name: "Ourinhos", state: "São Paulo" },
      { name: "Poá", state: "São Paulo" },
      { name: "Assis", state: "São Paulo" },
      { name: "Aracaju", state: "Sergipe" },
      { name: "Nossa Senhora do Socorro", state: "Sergipe" },
      { name: "Itabaiana", state: "Sergipe" },
      { name: "Lagarto", state: "Sergipe" },
      { name: "Palmas", state: "Tocantins" },
      { name: "Araguaína", state: "Tocantins" },
    ],
  },
  CI: {
    states: [
      { name: "Abidjan", code: "CI-AB", minZip: 0, maxZip: 999999 },
      { name: "Bas-Sassandra", code: "CI-BS", minZip: 0, maxZip: 999999 },
      { name: "Comoé", code: "CI-CM", minZip: 0, maxZip: 999999 },
      { name: "Denguélé", code: "CI-DN", minZip: 0, maxZip: 999999 },
      { name: "Gôh-Djiboua", code: "CI-GD", minZip: 0, maxZip: 999999 },
      { name: "Lacs", code: "CI-LC", minZip: 0, maxZip: 999999 },
      { name: "Lagunes", code: "CI-LG", minZip: 0, maxZip: 999999 },
      { name: "Montagnes", code: "CI-MG", minZip: 0, maxZip: 999999 },
      {
        name: "Sassandra-Marahoué",
        code: "CI-SM",
        minZip: 0,
        maxZip: 999999,
      },
      { name: "Savanes", code: "CI-SV", minZip: 0, maxZip: 999999 },
      { name: "Vallée", code: "CI-VB", minZip: 0, maxZip: 999999 },
      { name: "Woroba", code: "CI-WR", minZip: 0, maxZip: 999999 },
      { name: "Yamoussoukro", code: "CI-YM", minZip: 0, maxZip: 999999 },
      { name: "Zanzan", code: "CI-ZZ", minZip: 0, maxZip: 999999 },
    ],
    cities: [],
  },
  CO: {
    states: [
      { name: "Amazonas", code: "CO-AM", minZip: 0, maxZip: 999999 },
      { name: "Antioquia", code: "CO-AN", minZip: 0, maxZip: 999999 },
      { name: "Arauca", code: "CO-AR", minZip: 0, maxZip: 999999 },
      { name: "Atlántico", code: "CO-AT", minZip: 0, maxZip: 999999 },
      { name: "Bogotá, D.C.", code: "CO-DC", minZip: 0, maxZip: 999999 },
      { name: "Bolívar", code: "CO-BL", minZip: 0, maxZip: 999999 },
      { name: "Boyacá", code: "CO-BY", minZip: 0, maxZip: 999999 },
      { name: "Caldas", code: "CO-CL", minZip: 0, maxZip: 999999 },
      { name: "Caquetá", code: "CO-CQ", minZip: 0, maxZip: 999999 },
      { name: "Casanare", code: "CO-CS", minZip: 0, maxZip: 999999 },
      { name: "Cauca", code: "CO-CA", minZip: 0, maxZip: 999999 },
      { name: "Cesar", code: "CO-CE", minZip: 0, maxZip: 999999 },
      { name: "Chocó", code: "CO-CH", minZip: 0, maxZip: 999999 },
      { name: "Córdoba", code: "CO-CO", minZip: 0, maxZip: 999999 },
      { name: "Cundinamarca", code: "CO-CU", minZip: 0, maxZip: 999999 },
      { name: "Guainía", code: "CO-GN", minZip: 0, maxZip: 999999 },
      { name: "Guaviare", code: "CO-GV", minZip: 0, maxZip: 999999 },
      { name: "Huila", code: "CO-HU", minZip: 0, maxZip: 999999 },
      { name: "La Guajira", code: "CO-LG", minZip: 0, maxZip: 999999 },
      { name: "Magdalena", code: "CO-MA", minZip: 0, maxZip: 999999 },
      { name: "Meta", code: "CO-ME", minZip: 0, maxZip: 999999 },
      { name: "Nariño", code: "CO-NA", minZip: 0, maxZip: 999999 },
      {
        name: "Norte de Santander",
        code: "CO-NS",
        minZip: 0,
        maxZip: 999999,
      },
      { name: "Putumayo", code: "CO-PU", minZip: 0, maxZip: 999999 },
      { name: "Quindío", code: "CO-QD", minZip: 0, maxZip: 999999 },
      { name: "Risaralda", code: "CO-RI", minZip: 0, maxZip: 999999 },
      {
        name: "San Andrés y Providencia",
        code: "CO-SA",
        minZip: 0,
        maxZip: 999999,
      },
      { name: "Santander", code: "CO-ST", minZip: 0, maxZip: 999999 },
      { name: "Sucre", code: "CO-SU", minZip: 0, maxZip: 999999 },
      { name: "Tolima", code: "CO-TO", minZip: 0, maxZip: 999999 },
      { name: "Valle del Cauca", code: "CO-VC", minZip: 0, maxZip: 999999 },
      { name: "Vaupés", code: "CO-VP", minZip: 0, maxZip: 999999 },
      { name: "Vichada", code: "CO-VD", minZip: 0, maxZip: 999999 },
    ],
    cities: [
      { name: "Leticia", state: "Amazonas" },
      { name: "Puerto Nariño", state: "Amazonas" },
      { name: "Cáceres", state: "Antioquia" },
      { name: "Caucasia", state: "Antioquia" },
      { name: "El Bagre", state: "Antioquia" },
      { name: "Nechí", state: "Antioquia" },
      { name: "Tarazá", state: "Antioquia" },
      { name: "Zaragoza", state: "Antioquia" },
      { name: "Caracolí", state: "Antioquia" },
      { name: "Maceo", state: "Antioquia" },
      { name: "Puerto Berrío", state: "Antioquia" },
      { name: "Puerto Nare", state: "Antioquia" },
      { name: "Puerto Triunfo", state: "Antioquia" },
      { name: "Yondó", state: "Antioquia" },
      { name: "Amalfi", state: "Antioquia" },
      { name: "Anorí", state: "Antioquia" },
      { name: "Cisneros", state: "Antioquia" },
      { name: "Remedios", state: "Antioquia" },
      { name: "San Roque", state: "Antioquia" },
      { name: "Santo Domingo", state: "Antioquia" },
      { name: "Segovia", state: "Antioquia" },
      { name: "Vegachí", state: "Antioquia" },
      { name: "Yalí", state: "Antioquia" },
      { name: "Yolombó", state: "Antioquia" },
      { name: "Angostura", state: "Antioquia" },
      { name: "Belmira", state: "Antioquia" },
      { name: "Briceño", state: "Antioquia" },
      { name: "Campamento", state: "Antioquia" },
      { name: "Carolina del Príncipe", state: "Antioquia" },
      { name: "Donmatías", state: "Antioquia" },
      { name: "Entrerríos", state: "Antioquia" },
      { name: "Gómez Plata", state: "Antioquia" },
      { name: "Guadalupe", state: "Antioquia" },
      { name: "Ituango", state: "Antioquia" },
      { name: "San Andrés de Cuerquia", state: "Antioquia" },
      { name: "San José de la Montaña", state: "Antioquia" },
      { name: "San Pedro de los Milagros", state: "Antioquia" },
      { name: "Santa Rosa de Osos", state: "Antioquia" },
      { name: "Toledo", state: "Antioquia" },
      { name: "Valdivia", state: "Antioquia" },
      { name: "Yarumal", state: "Antioquia" },
      { name: "Abriaquí", state: "Antioquia" },
      { name: "Santa Fe de Antioquia", state: "Antioquia" },
      { name: "Anzá", state: "Antioquia" },
      { name: "Armenia", state: "Antioquia" },
      { name: "Buriticá", state: "Antioquia" },
      { name: "Caicedo", state: "Antioquia" },
      { name: "Cañasgordas", state: "Antioquia" },
      { name: "Dabeiba", state: "Antioquia" },
      { name: "Ebéjico", state: "Antioquia" },
      { name: "Frontino", state: "Antioquia" },
      { name: "Giraldo", state: "Antioquia" },
      { name: "Heliconia", state: "Antioquia" },
      { name: "Liborina", state: "Antioquia" },
      { name: "Olaya", state: "Antioquia" },
      { name: "Peque", state: "Antioquia" },
      { name: "Sabanalarga", state: "Antioquia" },
      { name: "San Jerónimo", state: "Antioquia" },
      { name: "Sopetrán", state: "Antioquia" },
      { name: "Uramita", state: "Antioquia" },
      { name: "Abejorral", state: "Antioquia" },
      { name: "Alejandría", state: "Antioquia" },
      { name: "Argelia", state: "Antioquia" },
      { name: "El Carmen de Viboral", state: "Antioquia" },
      { name: "Cocorná", state: "Antioquia" },
      { name: "Concepción", state: "Antioquia" },
      { name: "El Peñol", state: "Antioquia" },
      { name: "El Retiro", state: "Antioquia" },
      { name: "El Santuario", state: "Antioquia" },
      { name: "Granada", state: "Antioquia" },
      { name: "Guarne", state: "Antioquia" },
      { name: "Guatapé", state: "Antioquia" },
      { name: "La Ceja", state: "Antioquia" },
      { name: "La Unión", state: "Antioquia" },
      { name: "Marinilla", state: "Antioquia" },
      { name: "Nariño", state: "Antioquia" },
      { name: "Rionegro", state: "Antioquia" },
      { name: "San Carlos", state: "Antioquia" },
      { name: "San Francisco", state: "Antioquia" },
      { name: "San Luis", state: "Antioquia" },
      { name: "San Rafael", state: "Antioquia" },
      { name: "San Vicente", state: "Antioquia" },
      { name: "Sonsón", state: "Antioquia" },
      { name: "Amagá", state: "Antioquia" },
      { name: "Andes", state: "Antioquia" },
      { name: "Angelópolis", state: "Antioquia" },
      { name: "Betania", state: "Antioquia" },
      { name: "Betulia", state: "Antioquia" },
      { name: "Caramanta", state: "Antioquia" },
      { name: "Ciudad Bolívar", state: "Antioquia" },
      { name: "Concordia", state: "Antioquia" },
      { name: "Fredonia", state: "Antioquia" },
      { name: "Hispania", state: "Antioquia" },
      { name: "Jardín", state: "Antioquia" },
      { name: "Jericó", state: "Antioquia" },
      { name: "La Pintada", state: "Antioquia" },
      { name: "Montebello", state: "Antioquia" },
      { name: "Pueblorrico", state: "Antioquia" },
      { name: "Salgar", state: "Antioquia" },
      { name: "Santa Bárbara", state: "Antioquia" },
      { name: "Támesis", state: "Antioquia" },
      { name: "Tarso", state: "Antioquia" },
      { name: "Titiribí", state: "Antioquia" },
      { name: "Urrao", state: "Antioquia" },
      { name: "Valparaíso", state: "Antioquia" },
      { name: "Venecia", state: "Antioquia" },
      { name: "Apartadó", state: "Antioquia" },
      { name: "Arboletes", state: "Antioquia" },
      { name: "Carepa", state: "Antioquia" },
      { name: "Chigorodó", state: "Antioquia" },
      { name: "Murindó", state: "Antioquia" },
      { name: "Mutatá", state: "Antioquia" },
      { name: "Necoclí", state: "Antioquia" },
      { name: "San Juan de Urabá", state: "Antioquia" },
      { name: "San Pedro de Urabá", state: "Antioquia" },
      { name: "Turbo", state: "Antioquia" },
      { name: "Vigía del Fuerte", state: "Antioquia" },
      { name: "Barbosa", state: "Antioquia" },
      { name: "Bello", state: "Antioquia" },
      { name: "Caldas", state: "Antioquia" },
      { name: "Copacabana", state: "Antioquia" },
      { name: "Envigado", state: "Antioquia" },
      { name: "Girardota", state: "Antioquia" },
      { name: "Itagüí", state: "Antioquia" },
      { name: "La Estrella", state: "Antioquia" },
      { name: "Medellín", state: "Antioquia" },
      { name: "Sabaneta", state: "Antioquia" },
      { name: "Arauca", state: "Arauca" },
      { name: "Arauquita", state: "Arauca" },
      { name: "Cravo Norte", state: "Arauca" },
      { name: "Fortul", state: "Arauca" },
      { name: "Puerto Rondón", state: "Arauca" },
      { name: "Saravena", state: "Arauca" },
      { name: "Tame", state: "Arauca" },
      { name: "Barranquilla", state: "Atlántico" },
      { name: "Baranoa", state: "Atlántico" },
      { name: "Campo de la Cruz", state: "Atlántico" },
      { name: "Candelaria", state: "Atlántico" },
      { name: "Galapa", state: "Atlántico" },
      { name: "Juan de Acosta", state: "Atlántico" },
      { name: "Luruaco", state: "Atlántico" },
      { name: "Malambo", state: "Atlántico" },
      { name: "Manatí", state: "Atlántico" },
      { name: "Palmar de Varela", state: "Atlántico" },
      { name: "Piojó", state: "Atlántico" },
      { name: "Polonuevo", state: "Atlántico" },
      { name: "Ponedera", state: "Atlántico" },
      { name: "Puerto Colombia", state: "Atlántico" },
      { name: "Repelón", state: "Atlántico" },
      { name: "Sabanagrande", state: "Atlántico" },
      { name: "Sabanalarga", state: "Atlántico" },
      { name: "Santa Lucía", state: "Atlántico" },
      { name: "Santo Tomás", state: "Atlántico" },
      { name: "Soledad", state: "Atlántico" },
      { name: "Suan", state: "Atlántico" },
      { name: "Tubará", state: "Atlántico" },
      { name: "Usiacurí", state: "Atlántico" },
      { name: "Bogotá", state: "Bogotá, D.C." },
      { name: "Achí", state: "Bolívar" },
      { name: "Altos del Rosario", state: "Bolívar" },
      { name: "Arenal", state: "Bolívar" },
      { name: "Arjona", state: "Bolívar" },
      { name: "Arroyohondo", state: "Bolívar" },
      { name: "Barranco de Loba", state: "Bolívar" },
      { name: "Calamar", state: "Bolívar" },
      { name: "Cantagallo", state: "Bolívar" },
      { name: "El Carmen de Bolívar", state: "Bolívar" },
      { name: "Cartagena de Indias", state: "Bolívar" },
      { name: "Cicuco", state: "Bolívar" },
      { name: "Clemencia", state: "Bolívar" },
      { name: "Córdoba", state: "Bolívar" },
      { name: "El Guamo", state: "Bolívar" },
      { name: "El Peñón", state: "Bolívar" },
      { name: "Hatillo de Loba", state: "Bolívar" },
      { name: "Magangué", state: "Bolívar" },
      { name: "Mahates", state: "Bolívar" },
      { name: "Margarita", state: "Bolívar" },
      { name: "María La Baja", state: "Bolívar" },
      { name: "Montecristo", state: "Bolívar" },
      { name: "Morales", state: "Bolívar" },
      { name: "Norosí", state: "Bolívar" },
      { name: "Pinillos", state: "Bolívar" },
      { name: "Regidor", state: "Bolívar" },
      { name: "Río Viejo", state: "Bolívar" },
      { name: "San Cristóbal", state: "Bolívar" },
      { name: "San Estanislao", state: "Bolívar" },
      { name: "San Fernando", state: "Bolívar" },
      { name: "San Jacinto", state: "Bolívar" },
      { name: "San Jacinto del Cauca", state: "Bolívar" },
      { name: "San Juan Nepomuceno", state: "Bolívar" },
      { name: "San Martín de Loba", state: "Bolívar" },
      { name: "San Pablo", state: "Bolívar" },
      { name: "Santa Catalina", state: "Bolívar" },
      { name: "Santa Cruz de Mompox", state: "Bolívar" },
      { name: "Santa Rosa", state: "Bolívar" },
      { name: "Santa Rosa del Sur", state: "Bolívar" },
      { name: "Simití", state: "Bolívar" },
      { name: "Soplaviento", state: "Bolívar" },
      { name: "Talaigua Nuevo", state: "Bolívar" },
      { name: "Tiquisio", state: "Bolívar" },
      { name: "Turbaco", state: "Bolívar" },
      { name: "Turbaná", state: "Bolívar" },
      { name: "Villanueva", state: "Bolívar" },
      { name: "Zambrano", state: "Bolívar" },
      { name: "Chíquiza", state: "Boyacá" },
      { name: "Chivatá", state: "Boyacá" },
      { name: "Cómbita", state: "Boyacá" },
      { name: "Cucaita", state: "Boyacá" },
      { name: "Motavita", state: "Boyacá" },
      { name: "Oicatá", state: "Boyacá" },
      { name: "Samacá", state: "Boyacá" },
      { name: "Siachoque", state: "Boyacá" },
      { name: "Sora", state: "Boyacá" },
      { name: "Soracá", state: "Boyacá" },
      { name: "Sotaquirá", state: "Boyacá" },
      { name: "Toca", state: "Boyacá" },
      { name: "Tunja", state: "Boyacá" },
      { name: "Tuta", state: "Boyacá" },
      { name: "Ventaquemada", state: "Boyacá" },
      { name: "Chiscas", state: "Boyacá" },
      { name: "El Cocuy", state: "Boyacá" },
      { name: "El Espino", state: "Boyacá" },
      { name: "Guacamayas", state: "Boyacá" },
      { name: "Güicán", state: "Boyacá" },
      { name: "Panqueba", state: "Boyacá" },
      { name: "Labranzagrande", state: "Boyacá" },
      { name: "Pajarito", state: "Boyacá" },
      { name: "Paya", state: "Boyacá" },
      { name: "Pisba", state: "Boyacá" },
      { name: "Berbeo", state: "Boyacá" },
      { name: "Campohermoso", state: "Boyacá" },
      { name: "Miraflores", state: "Boyacá" },
      { name: "Páez", state: "Boyacá" },
      { name: "San Eduardo", state: "Boyacá" },
      { name: "Zetaquira", state: "Boyacá" },
      { name: "Boyacá", state: "Boyacá" },
      { name: "Ciénega", state: "Boyacá" },
      { name: "Jenesano", state: "Boyacá" },
      { name: "Nuevo Colón", state: "Boyacá" },
      { name: "Ramiriquí", state: "Boyacá" },
      { name: "Rondón", state: "Boyacá" },
      { name: "Tibaná", state: "Boyacá" },
      { name: "Turmequé", state: "Boyacá" },
      { name: "Úmbita", state: "Boyacá" },
      { name: "Viracachá", state: "Boyacá" },
      { name: "Chinavita", state: "Boyacá" },
      { name: "Garagoa", state: "Boyacá" },
      { name: "Macanal", state: "Boyacá" },
      { name: "Pachavita", state: "Boyacá" },
      { name: "San Luis de Gaceno", state: "Boyacá" },
      { name: "Santa María", state: "Boyacá" },
      { name: "Boavita", state: "Boyacá" },
      { name: "Covarachía", state: "Boyacá" },
      { name: "La Uvita", state: "Boyacá" },
      { name: "San Mateo", state: "Boyacá" },
      { name: "Sativanorte", state: "Boyacá" },
      { name: "Sativasur", state: "Boyacá" },
      { name: "Soatá", state: "Boyacá" },
      { name: "Susacón", state: "Boyacá" },
      { name: "Tipacoque", state: "Boyacá" },
      { name: "Briceño", state: "Boyacá" },
      { name: "Buenavista", state: "Boyacá" },
      { name: "Caldas", state: "Boyacá" },
      { name: "Chiquinquirá", state: "Boyacá" },
      { name: "Coper", state: "Boyacá" },
      { name: "La Victoria", state: "Boyacá" },
      { name: "Maripí", state: "Boyacá" },
      { name: "Muzo", state: "Boyacá" },
      { name: "Otanche", state: "Boyacá" },
      { name: "Pauna", state: "Boyacá" },
      { name: "Quípama", state: "Boyacá" },
      { name: "Saboyá", state: "Boyacá" },
      { name: "San Miguel de Sema", state: "Boyacá" },
      { name: "San Pablo de Borbur", state: "Boyacá" },
      { name: "Tununguá", state: "Boyacá" },
      { name: "Almeida", state: "Boyacá" },
      { name: "Chivor", state: "Boyacá" },
      { name: "Guateque", state: "Boyacá" },
      { name: "Guayatá", state: "Boyacá" },
      { name: "La Capilla", state: "Boyacá" },
      { name: "Somondoco", state: "Boyacá" },
      { name: "Sutatenza", state: "Boyacá" },
      { name: "Tenza", state: "Boyacá" },
      { name: "Arcabuco", state: "Boyacá" },
      { name: "Chitaraque", state: "Boyacá" },
      { name: "Gachantivá", state: "Boyacá" },
      { name: "Moniquirá", state: "Boyacá" },
      { name: "Ráquira", state: "Boyacá" },
      { name: "Sáchica", state: "Boyacá" },
      { name: "San José de Pare", state: "Boyacá" },
      { name: "Santa Sofía", state: "Boyacá" },
      { name: "Santana", state: "Boyacá" },
      { name: "Sutamarchán", state: "Boyacá" },
      { name: "Tinjacá", state: "Boyacá" },
      { name: "Togüí", state: "Boyacá" },
      { name: "Villa de Leyva", state: "Boyacá" },
      { name: "Aquitania", state: "Boyacá" },
      { name: "Cuítiva", state: "Boyacá" },
      { name: "Firavitoba", state: "Boyacá" },
      { name: "Gámeza", state: "Boyacá" },
      { name: "Iza", state: "Boyacá" },
      { name: "Mongua", state: "Boyacá" },
      { name: "Monguí", state: "Boyacá" },
      { name: "Nobsa", state: "Boyacá" },
      { name: "Pesca", state: "Boyacá" },
      { name: "Sogamoso", state: "Boyacá" },
      { name: "Tibasosa", state: "Boyacá" },
      { name: "Tópaga", state: "Boyacá" },
      { name: "Tota", state: "Boyacá" },
      { name: "Belén", state: "Boyacá" },
      { name: "Busbanzá", state: "Boyacá" },
      { name: "Cerinza", state: "Boyacá" },
      { name: "Corrales", state: "Boyacá" },
      { name: "Duitama", state: "Boyacá" },
      { name: "Floresta", state: "Boyacá" },
      { name: "Paipa", state: "Boyacá" },
      { name: "Santa Rosa de Viterbo", state: "Boyacá" },
      { name: "Tutazá", state: "Boyacá" },
      { name: "Betéitiva", state: "Boyacá" },
      { name: "Chita", state: "Boyacá" },
      { name: "Jericó", state: "Boyacá" },
      { name: "Paz de Río", state: "Boyacá" },
      { name: "Socha", state: "Boyacá" },
      { name: "Socotá", state: "Boyacá" },
      { name: "Tasco", state: "Boyacá" },
      { name: "Cubará", state: "Boyacá" },
      { name: "Puerto Boyacá", state: "Boyacá" },
      { name: "Filadelfia", state: "Caldas" },
      { name: "La Merced", state: "Caldas" },
      { name: "Marmato", state: "Caldas" },
      { name: "Riosucio", state: "Caldas" },
      { name: "Supía", state: "Caldas" },
      { name: "Manzanares", state: "Caldas" },
      { name: "Marquetalia", state: "Caldas" },
      { name: "Marulanda", state: "Caldas" },
      { name: "Pensilvania", state: "Caldas" },
      { name: "Anserma", state: "Caldas" },
      { name: "Belalcázar", state: "Caldas" },
      { name: "Risaralda", state: "Caldas" },
      { name: "San José", state: "Caldas" },
      { name: "Viterbo", state: "Caldas" },
      { name: "Chinchiná", state: "Caldas" },
      { name: "Manizales", state: "Caldas" },
      { name: "Neira", state: "Caldas" },
      { name: "Palestina", state: "Caldas" },
      { name: "Villamaría", state: "Caldas" },
      { name: "La Dorada", state: "Caldas" },
      { name: "Norcasia", state: "Caldas" },
      { name: "Samaná", state: "Caldas" },
      { name: "Victoria", state: "Caldas" },
      { name: "Aguadas", state: "Caldas" },
      { name: "Aranzazu", state: "Caldas" },
      { name: "Pácora", state: "Caldas" },
      { name: "Salamina", state: "Caldas" },
      { name: "Albania", state: "Caquetá" },
      { name: "Belén de los Andaquíes", state: "Caquetá" },
      { name: "Cartagena del Chairá", state: "Caquetá" },
      { name: "Curillo", state: "Caquetá" },
      { name: "El Doncello", state: "Caquetá" },
      { name: "El Paujil", state: "Caquetá" },
      { name: "Florencia", state: "Caquetá" },
      { name: "La Montañita", state: "Caquetá" },
      { name: "Morelia", state: "Caquetá" },
      { name: "Puerto Milán", state: "Caquetá" },
      { name: "Puerto Rico", state: "Caquetá" },
      { name: "San José del Fragua", state: "Caquetá" },
      { name: "San Vicente del Caguán", state: "Caquetá" },
      { name: "Solano", state: "Caquetá" },
      { name: "Solita", state: "Caquetá" },
      { name: "Valparaíso", state: "Caquetá" },
      { name: "Aguazul", state: "Casanare" },
      { name: "Chámeza", state: "Casanare" },
      { name: "Hato Corozal", state: "Casanare" },
      { name: "La Salina", state: "Casanare" },
      { name: "Maní", state: "Casanare" },
      { name: "Monterrey", state: "Casanare" },
      { name: "Nunchía", state: "Casanare" },
      { name: "Orocué", state: "Casanare" },
      { name: "Paz de Ariporo", state: "Casanare" },
      { name: "Pore", state: "Casanare" },
      { name: "Recetor", state: "Casanare" },
      { name: "Sabanalarga", state: "Casanare" },
      { name: "Sácama", state: "Casanare" },
      { name: "San Luis de Palenque", state: "Casanare" },
      { name: "Támara", state: "Casanare" },
      { name: "Tauramena", state: "Casanare" },
      { name: "Trinidad", state: "Casanare" },
      { name: "Villanueva", state: "Casanare" },
      { name: "Yopal", state: "Casanare" },
      { name: "Buenos Aires", state: "Cauca" },
      { name: "Caloto", state: "Cauca" },
      { name: "Corinto", state: "Cauca" },
      { name: "Guachené", state: "Cauca" },
      { name: "Miranda", state: "Cauca" },
      { name: "Padilla", state: "Cauca" },
      { name: "Puerto Tejada", state: "Cauca" },
      { name: "Santander de Quilichao", state: "Cauca" },
      { name: "Suárez", state: "Cauca" },
      { name: "Villa Rica", state: "Cauca" },
      { name: "Cajibío", state: "Cauca" },
      { name: "El Tambo", state: "Cauca" },
      { name: "La Sierra", state: "Cauca" },
      { name: "Morales", state: "Cauca" },
      { name: "Piendamó", state: "Cauca" },
      { name: "Popayán", state: "Cauca" },
      { name: "Rosas", state: "Cauca" },
      { name: "Sotará", state: "Cauca" },
      { name: "Timbío", state: "Cauca" },
      { name: "Almaguer", state: "Cauca" },
      { name: "Argelia", state: "Cauca" },
      { name: "Balboa", state: "Cauca" },
      { name: "Bolívar", state: "Cauca" },
      { name: "Florencia", state: "Cauca" },
      { name: "La Vega", state: "Cauca" },
      { name: "Mercaderes", state: "Cauca" },
      { name: "Patía", state: "Cauca" },
      { name: "Piamonte", state: "Cauca" },
      { name: "San Sebastián", state: "Cauca" },
      { name: "Santa Rosa", state: "Cauca" },
      { name: "Sucre", state: "Cauca" },
      { name: "Guapi", state: "Cauca" },
      { name: "López de Micay", state: "Cauca" },
      { name: "Timbiquí", state: "Cauca" },
      { name: "Caldono", state: "Cauca" },
      { name: "Inzá", state: "Cauca" },
      { name: "Jambaló", state: "Cauca" },
      { name: "Páez", state: "Cauca" },
      { name: "Puracé - Coconuco", state: "Cauca" },
      { name: "Silvia", state: "Cauca" },
      { name: "Toribío", state: "Cauca" },
      { name: "Totoró", state: "Cauca" },
      { name: "Valledupar", state: "Cesar" },
      { name: "Aguachica", state: "Cesar" },
      { name: "Agustín Codazzi", state: "Cesar" },
      { name: "Bosconia", state: "Cesar" },
      { name: "Chimichagua", state: "Cesar" },
      { name: "El Copey", state: "Cesar" },
      { name: "San Alberto", state: "Cesar" },
      { name: "Curumaní", state: "Cesar" },
      { name: "El Paso", state: "Cesar" },
      { name: "La Paz", state: "Cesar" },
      { name: "Pueblo Bello", state: "Cesar" },
      { name: "La Jagua de Ibirico", state: "Cesar" },
      { name: "Chiriguaná", state: "Cesar" },
      { name: "Astrea", state: "Cesar" },
      { name: "San Martín", state: "Cesar" },
      { name: "Pelaya", state: "Cesar" },
      { name: "Pailitas", state: "Cesar" },
      { name: "Gamarra", state: "Cesar" },
      { name: "Manaure", state: "Cesar" },
      { name: "Río de Oro", state: "Cesar" },
      { name: "Tamalameque", state: "Cesar" },
      { name: "Becerril", state: "Cesar" },
      { name: "San Diego", state: "Cesar" },
      { name: "La Gloria", state: "Cesar" },
      { name: "González", state: "Cesar" },
      { name: "Acandí", state: "Chocó" },
      { name: "Alto Baudó", state: "Chocó" },
      { name: "Atrato", state: "Chocó" },
      { name: "Bagadó", state: "Chocó" },
      { name: "Bahía Solano", state: "Chocó" },
      { name: "Bajo Baudó", state: "Chocó" },
      { name: "Belén de Bajirá", state: "Chocó" },
      { name: "Bojayá", state: "Chocó" },
      { name: "Carmen del Darién", state: "Chocó" },
      { name: "Cértegui", state: "Chocó" },
      { name: "Condoto", state: "Chocó" },
      { name: "El Cantón de San Pablo", state: "Chocó" },
      { name: "El Carmen de Atrato", state: "Chocó" },
      { name: "El Litoral de San Juan", state: "Chocó" },
      { name: "Istmina", state: "Chocó" },
      { name: "Juradó", state: "Chocó" },
      { name: "Lloró", state: "Chocó" },
      { name: "Medio Atrato", state: "Chocó" },
      { name: "Medio Baudó", state: "Chocó" },
      { name: "Medio San Juan", state: "Chocó" },
      { name: "Nóvita", state: "Chocó" },
      { name: "Nuquí", state: "Chocó" },
      { name: "Quibdó", state: "Chocó" },
      { name: "Río Iró", state: "Chocó" },
      { name: "Río Quito", state: "Chocó" },
      { name: "Riosucio", state: "Chocó" },
      { name: "San José del Palmar", state: "Chocó" },
      { name: "Sipí", state: "Chocó" },
      { name: "Tadó", state: "Chocó" },
      { name: "Unguía", state: "Chocó" },
      { name: "Unión Panamericana", state: "Chocó" },
      { name: "Ayapel", state: "Córdoba" },
      { name: "Buenavista", state: "Córdoba" },
      { name: "Canalete", state: "Córdoba" },
      { name: "Cereté", state: "Córdoba" },
      { name: "Chimá", state: "Córdoba" },
      { name: "Chinú", state: "Córdoba" },
      { name: "Ciénaga de Oro", state: "Córdoba" },
      { name: "Cotorra", state: "Córdoba" },
      { name: "La Apartada", state: "Córdoba" },
      { name: "Los Córdobas", state: "Córdoba" },
      { name: "Momil", state: "Córdoba" },
      { name: "Montelíbano", state: "Córdoba" },
      { name: "Montería", state: "Córdoba" },
      { name: "Moñitos", state: "Córdoba" },
      { name: "Planeta Rica", state: "Córdoba" },
      { name: "Pueblo Nuevo", state: "Córdoba" },
      { name: "Puerto Escondido", state: "Córdoba" },
      { name: "Puerto Libertador", state: "Córdoba" },
      { name: "Purísima", state: "Córdoba" },
      { name: "Sahagún", state: "Córdoba" },
      { name: "San Andrés de Sotavento", state: "Córdoba" },
      { name: "San Antero", state: "Córdoba" },
      { name: "San Bernardo del Viento", state: "Córdoba" },
      { name: "San Carlos", state: "Córdoba" },
      { name: "San José de Uré", state: "Córdoba" },
      { name: "San Pelayo", state: "Córdoba" },
      { name: "Santa Cruz de Lorica", state: "Córdoba" },
      { name: "Tierralta", state: "Córdoba" },
      { name: "Tuchín", state: "Córdoba" },
      { name: "Valencia", state: "Córdoba" },
      { name: "Chocontá", state: "Cundinamarca" },
      { name: "Machetá", state: "Cundinamarca" },
      { name: "Manta", state: "Cundinamarca" },
      { name: "Sesquilé", state: "Cundinamarca" },
      { name: "Suesca", state: "Cundinamarca" },
      { name: "Tibirita", state: "Cundinamarca" },
      { name: "Villapinzón", state: "Cundinamarca" },
      { name: "Agua de Dios", state: "Cundinamarca" },
      { name: "Girardot", state: "Cundinamarca" },
      { name: "Guataquí", state: "Cundinamarca" },
      { name: "Jerusalén", state: "Cundinamarca" },
      { name: "Nariño", state: "Cundinamarca" },
      { name: "Nilo", state: "Cundinamarca" },
      { name: "Ricaurte", state: "Cundinamarca" },
      { name: "Tocaima", state: "Cundinamarca" },
      { name: "Caparrapí", state: "Cundinamarca" },
      { name: "Guaduas", state: "Cundinamarca" },
      { name: "Puerto Salgar", state: "Cundinamarca" },
      { name: "Albán", state: "Cundinamarca" },
      { name: "La Peña", state: "Cundinamarca" },
      { name: "La Vega", state: "Cundinamarca" },
      { name: "Nimaima", state: "Cundinamarca" },
      { name: "Nocaima", state: "Cundinamarca" },
      { name: "Quebradanegra", state: "Cundinamarca" },
      { name: "San Francisco", state: "Cundinamarca" },
      { name: "Sasaima", state: "Cundinamarca" },
      { name: "Supatá", state: "Cundinamarca" },
      { name: "Útica", state: "Cundinamarca" },
      { name: "Vergara", state: "Cundinamarca" },
      { name: "Villeta", state: "Cundinamarca" },
      { name: "Gachalá", state: "Cundinamarca" },
      { name: "Gachetá", state: "Cundinamarca" },
      { name: "Gama", state: "Cundinamarca" },
      { name: "Guasca", state: "Cundinamarca" },
      { name: "Guatavita", state: "Cundinamarca" },
      { name: "Junín", state: "Cundinamarca" },
      { name: "La Calera", state: "Cundinamarca" },
      { name: "Ubalá", state: "Cundinamarca" },
      { name: "Beltrán", state: "Cundinamarca" },
      { name: "Bituima", state: "Cundinamarca" },
      { name: "Chaguaní", state: "Cundinamarca" },
      { name: "Guayabal de Síquima", state: "Cundinamarca" },
      { name: "Pulí", state: "Cundinamarca" },
      { name: "San Juan de Rioseco", state: "Cundinamarca" },
      { name: "Vianí", state: "Cundinamarca" },
      { name: "Medina", state: "Cundinamarca" },
      { name: "Paratebueno", state: "Cundinamarca" },
      { name: "Cáqueza", state: "Cundinamarca" },
      { name: "Chipaque", state: "Cundinamarca" },
      { name: "Choachí", state: "Cundinamarca" },
      { name: "Fómeque", state: "Cundinamarca" },
      { name: "Fosca", state: "Cundinamarca" },
      { name: "Guayabetal", state: "Cundinamarca" },
      { name: "Gutiérrez", state: "Cundinamarca" },
      { name: "Quetame", state: "Cundinamarca" },
      { name: "Ubaque", state: "Cundinamarca" },
      { name: "Une", state: "Cundinamarca" },
      { name: "El Peñón", state: "Cundinamarca" },
      { name: "La Palma", state: "Cundinamarca" },
      { name: "Pacho", state: "Cundinamarca" },
      { name: "Paime", state: "Cundinamarca" },
      { name: "San Cayetano", state: "Cundinamarca" },
      { name: "Topaipí", state: "Cundinamarca" },
      { name: "Villagómez", state: "Cundinamarca" },
      { name: "Yacopí", state: "Cundinamarca" },
      { name: "Cajicá", state: "Cundinamarca" },
      { name: "Chía", state: "Cundinamarca" },
      { name: "Cogua", state: "Cundinamarca" },
      { name: "Cota", state: "Cundinamarca" },
      { name: "Gachancipá", state: "Cundinamarca" },
      { name: "Nemocón", state: "Cundinamarca" },
      { name: "Sopó", state: "Cundinamarca" },
      { name: "Tabio", state: "Cundinamarca" },
      { name: "Tenjo", state: "Cundinamarca" },
      { name: "Tocancipá", state: "Cundinamarca" },
      { name: "Zipaquirá", state: "Cundinamarca" },
      { name: "Bojacá", state: "Cundinamarca" },
      { name: "El Rosal", state: "Cundinamarca" },
      { name: "Facatativá", state: "Cundinamarca" },
      { name: "Funza", state: "Cundinamarca" },
      { name: "Madrid", state: "Cundinamarca" },
      { name: "Mosquera", state: "Cundinamarca" },
      { name: "Subachoque", state: "Cundinamarca" },
      { name: "Zipacón", state: "Cundinamarca" },
      { name: "Sibaté", state: "Cundinamarca" },
      { name: "Soacha", state: "Cundinamarca" },
      { name: "Arbeláez", state: "Cundinamarca" },
      { name: "Cabrera", state: "Cundinamarca" },
      { name: "Fusagasugá", state: "Cundinamarca" },
      { name: "Granada", state: "Cundinamarca" },
      { name: "Pandi", state: "Cundinamarca" },
      { name: "Pasca", state: "Cundinamarca" },
      { name: "San Bernardo", state: "Cundinamarca" },
      { name: "Silvania", state: "Cundinamarca" },
      { name: "Tibacuy", state: "Cundinamarca" },
      { name: "Venecia", state: "Cundinamarca" },
      { name: "Anapoima", state: "Cundinamarca" },
      { name: "Anolaima", state: "Cundinamarca" },
      { name: "Apulo", state: "Cundinamarca" },
      { name: "Cachipay", state: "Cundinamarca" },
      { name: "El Colegio", state: "Cundinamarca" },
      { name: "La Mesa", state: "Cundinamarca" },
      { name: "Quipile", state: "Cundinamarca" },
      { name: "San Antonio del Tequendama", state: "Cundinamarca" },
      { name: "Tena", state: "Cundinamarca" },
      { name: "Viotá", state: "Cundinamarca" },
      { name: "Carmen de Carupa", state: "Cundinamarca" },
      { name: "Cucunubá", state: "Cundinamarca" },
      { name: "Fúquene", state: "Cundinamarca" },
      { name: "Guachetá", state: "Cundinamarca" },
      { name: "Lenguazaque", state: "Cundinamarca" },
      { name: "Simijaca", state: "Cundinamarca" },
      { name: "Susa", state: "Cundinamarca" },
      { name: "Sutatausa", state: "Cundinamarca" },
      { name: "Tausa", state: "Cundinamarca" },
      { name: "Ubaté", state: "Cundinamarca" },
      { name: "Barrancominas", state: "Guainía" },
      { name: "Inírida", state: "Guainía" },
      { name: "Calamar", state: "Guaviare" },
      { name: "El Retorno", state: "Guaviare" },
      { name: "Miraflores", state: "Guaviare" },
      { name: "San José del Guaviare", state: "Guaviare" },
      { name: "Aipe", state: "Huila" },
      { name: "Algeciras", state: "Huila" },
      { name: "Baraya", state: "Huila" },
      { name: "Campoalegre", state: "Huila" },
      { name: "Colombia", state: "Huila" },
      { name: "Hobo", state: "Huila" },
      { name: "Íquira", state: "Huila" },
      { name: "Neiva", state: "Huila" },
      { name: "Palermo", state: "Huila" },
      { name: "Rivera", state: "Huila" },
      { name: "Santa María", state: "Huila" },
      { name: "Tello", state: "Huila" },
      { name: "Teruel", state: "Huila" },
      { name: "Villavieja", state: "Huila" },
      { name: "Yaguará", state: "Huila" },
      { name: "Agrado", state: "Huila" },
      { name: "Altamira", state: "Huila" },
      { name: "Garzón", state: "Huila" },
      { name: "Gigante", state: "Huila" },
      { name: "Guadalupe", state: "Huila" },
      { name: "Pital", state: "Huila" },
      { name: "Suaza", state: "Huila" },
      { name: "Tarqui", state: "Huila" },
      { name: "La Argentina", state: "Huila" },
      { name: "La Plata", state: "Huila" },
      { name: "Nátaga", state: "Huila" },
      { name: "Paicol", state: "Huila" },
      { name: "Tesalia", state: "Huila" },
      { name: "Acevedo", state: "Huila" },
      { name: "Elías", state: "Huila" },
      { name: "Isnos", state: "Huila" },
      { name: "Oporapa", state: "Huila" },
      { name: "Palestina", state: "Huila" },
      { name: "Pitalito", state: "Huila" },
      { name: "Saladoblanco", state: "Huila" },
      { name: "San Agustín", state: "Huila" },
      { name: "Timaná", state: "Huila" },
      { name: "Albania", state: "La Guajira" },
      { name: "Barrancas", state: "La Guajira" },
      { name: "Dibulla", state: "La Guajira" },
      { name: "Distracción", state: "La Guajira" },
      { name: "El Molino", state: "La Guajira" },
      { name: "Fonseca", state: "La Guajira" },
      { name: "Hatonuevo", state: "La Guajira" },
      { name: "La Jagua del Pilar", state: "La Guajira" },
      { name: "Maicao", state: "La Guajira" },
      { name: "Manaure", state: "La Guajira" },
      { name: "Riohacha", state: "La Guajira" },
      { name: "San Juan del Cesar", state: "La Guajira" },
      { name: "Uribia", state: "La Guajira" },
      { name: "Urumita", state: "La Guajira" },
      { name: "Villanueva", state: "La Guajira" },
      { name: "Algarrobo", state: "Magdalena" },
      { name: "Aracataca", state: "Magdalena" },
      { name: "Ariguaní", state: "Magdalena" },
      { name: "Cerro de San Antonio", state: "Magdalena" },
      { name: "Chibolo", state: "Magdalena" },
      { name: "Ciénaga", state: "Magdalena" },
      { name: "Concordia", state: "Magdalena" },
      { name: "El Banco", state: "Magdalena" },
      { name: "El Piñón", state: "Magdalena" },
      { name: "El Retén", state: "Magdalena" },
      { name: "Fundación", state: "Magdalena" },
      { name: "Guamal", state: "Magdalena" },
      { name: "Nueva Granada", state: "Magdalena" },
      { name: "Pedraza", state: "Magdalena" },
      { name: "Pijiño del Carmen", state: "Magdalena" },
      { name: "Pivijay", state: "Magdalena" },
      { name: "Plato", state: "Magdalena" },
      { name: "Pueblo Viejo", state: "Magdalena" },
      { name: "Remolino", state: "Magdalena" },
      { name: "Sabanas de San Ángel", state: "Magdalena" },
      { name: "Salamina", state: "Magdalena" },
      { name: "San Sebastián de Buenavista", state: "Magdalena" },
      { name: "Santa Ana", state: "Magdalena" },
      { name: "Santa Bárbara de Pinto", state: "Magdalena" },
      { name: "Santa Marta", state: "Magdalena" },
      { name: "San Zenón", state: "Magdalena" },
      { name: "Sitionuevo", state: "Magdalena" },
      { name: "Tenerife", state: "Magdalena" },
      { name: "Zapayán", state: "Magdalena" },
      { name: "Zona Bananera", state: "Magdalena" },
      { name: "Acacías", state: "Meta" },
      { name: "Barranca de Upía", state: "Meta" },
      { name: "Cabuyaro", state: "Meta" },
      { name: "Castilla La Nueva", state: "Meta" },
      { name: "Cubarral", state: "Meta" },
      { name: "Cumaral", state: "Meta" },
      { name: "El Calvario", state: "Meta" },
      { name: "El Castillo", state: "Meta" },
      { name: "El Dorado", state: "Meta" },
      { name: "Fuente de Oro", state: "Meta" },
      { name: "Granada", state: "Meta" },
      { name: "Guamal", state: "Meta" },
      { name: "La Macarena", state: "Meta" },
      { name: "Uribe", state: "Meta" },
      { name: "Lejanías", state: "Meta" },
      { name: "Mapiripán", state: "Meta" },
      { name: "Mesetas", state: "Meta" },
      { name: "Puerto Concordia", state: "Meta" },
      { name: "Puerto Gaitán", state: "Meta" },
      { name: "Puerto Lleras", state: "Meta" },
      { name: "Puerto López", state: "Meta" },
      { name: "Puerto Rico", state: "Meta" },
      { name: "Restrepo", state: "Meta" },
      { name: "San Carlos de Guaroa", state: "Meta" },
      { name: "San Juan de Arama", state: "Meta" },
      { name: "San Juanito", state: "Meta" },
      { name: "San Martín", state: "Meta" },
      { name: "Villavicencio", state: "Meta" },
      { name: "Vista Hermosa", state: "Meta" },
      { name: "Barbacoas", state: "Nariño" },
      { name: "El Charco", state: "Nariño" },
      { name: "Francisco Pizarro", state: "Nariño" },
      { name: "La Tola", state: "Nariño" },
      { name: "Magüí Payán", state: "Nariño" },
      { name: "Mosquera", state: "Nariño" },
      { name: "Olaya Herrera", state: "Nariño" },
      { name: "Roberto Payán", state: "Nariño" },
      { name: "Santa Bárbara", state: "Nariño" },
      { name: "Tumaco", state: "Nariño" },
      { name: "Aldana", state: "Nariño" },
      { name: "Contadero", state: "Nariño" },
      { name: "Córdoba", state: "Nariño" },
      { name: "Cuaspud", state: "Nariño" },
      { name: "Cumbal", state: "Nariño" },
      { name: "Funes", state: "Nariño" },
      { name: "Guachucal", state: "Nariño" },
      { name: "Gualmatán", state: "Nariño" },
      { name: "Iles", state: "Nariño" },
      { name: "Ipiales", state: "Nariño" },
      { name: "Potosí", state: "Nariño" },
      { name: "Puerres", state: "Nariño" },
      { name: "Pupiales", state: "Nariño" },
      { name: "Albán", state: "Nariño" },
      { name: "Arboleda", state: "Nariño" },
      { name: "Belén", state: "Nariño" },
      { name: "Colón", state: "Nariño" },
      { name: "El Rosario", state: "Nariño" },
      { name: "El Tablón de Gómez", state: "Nariño" },
      { name: "La Cruz", state: "Nariño" },
      { name: "La Unión", state: "Nariño" },
      { name: "Leiva", state: "Nariño" },
      { name: "Policarpa", state: "Nariño" },
      { name: "San Bernardo", state: "Nariño" },
      { name: "San Lorenzo", state: "Nariño" },
      { name: "San Pablo", state: "Nariño" },
      { name: "San Pedro de Cartago", state: "Nariño" },
      { name: "Taminango", state: "Nariño" },
      { name: "Buesaco", state: "Nariño" },
      { name: "Chachagüí", state: "Nariño" },
      { name: "Consacá", state: "Nariño" },
      { name: "El Peñol", state: "Nariño" },
      { name: "El Tambo", state: "Nariño" },
      { name: "La Florida", state: "Nariño" },
      { name: "Nariño", state: "Nariño" },
      { name: "Pasto", state: "Nariño" },
      { name: "Sandoná", state: "Nariño" },
      { name: "Tangua", state: "Nariño" },
      { name: "Yacuanquer", state: "Nariño" },
      { name: "Ancuya", state: "Nariño" },
      { name: "Cumbitara", state: "Nariño" },
      { name: "Guaitarilla", state: "Nariño" },
      { name: "Imués", state: "Nariño" },
      { name: "La Llanada", state: "Nariño" },
      { name: "Linares", state: "Nariño" },
      { name: "Los Andes", state: "Nariño" },
      { name: "Mallama", state: "Nariño" },
      { name: "Ospina", state: "Nariño" },
      { name: "Providencia", state: "Nariño" },
      { name: "Ricaurte", state: "Nariño" },
      { name: "Samaniego", state: "Nariño" },
      { name: "Santacruz", state: "Nariño" },
      { name: "Sapuyes", state: "Nariño" },
      { name: "Túquerres", state: "Nariño" },
      { name: "Arboledas", state: "Norte de Santander" },
      { name: "Cucutilla", state: "Norte de Santander" },
      { name: "Gramalote", state: "Norte de Santander" },
      { name: "Lourdes", state: "Norte de Santander" },
      { name: "Salazar de Las Palmas", state: "Norte de Santander" },
      { name: "Santiago", state: "Norte de Santander" },
      { name: "Villa Caro", state: "Norte de Santander" },
      { name: "Cúcuta", state: "Norte de Santander" },
      { name: "El Zulia", state: "Norte de Santander" },
      { name: "Los Patios", state: "Norte de Santander" },
      { name: "Puerto Santander", state: "Norte de Santander" },
      { name: "San Cayetano", state: "Norte de Santander" },
      { name: "Villa del Rosario", state: "Norte de Santander" },
      { name: "Bucarasica", state: "Norte de Santander" },
      { name: "El Tarra", state: "Norte de Santander" },
      { name: "Sardinata", state: "Norte de Santander" },
      { name: "Tibú", state: "Norte de Santander" },
      { name: "Ábrego", state: "Norte de Santander" },
      { name: "Cáchira", state: "Norte de Santander" },
      { name: "Convención", state: "Norte de Santander" },
      { name: "El Carmen", state: "Norte de Santander" },
      { name: "Hacarí", state: "Norte de Santander" },
      { name: "La Esperanza", state: "Norte de Santander" },
      { name: "La Playa de Belén", state: "Norte de Santander" },
      { name: "Ocaña", state: "Norte de Santander" },
      { name: "San Calixto", state: "Norte de Santander" },
      { name: "Teorama", state: "Norte de Santander" },
      { name: "Cácota", state: "Norte de Santander" },
      { name: "Chitagá", state: "Norte de Santander" },
      { name: "Mutiscua", state: "Norte de Santander" },
      { name: "Pamplona", state: "Norte de Santander" },
      { name: "Pamplonita", state: "Norte de Santander" },
      { name: "Santo Domingo de Silos", state: "Norte de Santander" },
      { name: "Bochalema", state: "Norte de Santander" },
      { name: "Chinácota", state: "Norte de Santander" },
      { name: "Durania", state: "Norte de Santander" },
      { name: "Herrán", state: "Norte de Santander" },
      { name: "Labateca", state: "Norte de Santander" },
      { name: "Ragonvalia", state: "Norte de Santander" },
      { name: "Toledo", state: "Norte de Santander" },
      { name: "Colón", state: "Putumayo" },
      { name: "Mocoa", state: "Putumayo" },
      { name: "Orito", state: "Putumayo" },
      { name: "Puerto Asís", state: "Putumayo" },
      { name: "Puerto Caicedo", state: "Putumayo" },
      { name: "Puerto Guzmán", state: "Putumayo" },
      { name: "Puerto Leguízamo", state: "Putumayo" },
      { name: "San Francisco", state: "Putumayo" },
      { name: "San Miguel", state: "Putumayo" },
      { name: "Santiago", state: "Putumayo" },
      { name: "Sibundoy", state: "Putumayo" },
      { name: "Valle del Guamuez", state: "Putumayo" },
      { name: "Villagarzón", state: "Putumayo" },
      { name: "Armenia", state: "Quindío" },
      { name: "Buenavista", state: "Quindío" },
      { name: "Calarcá", state: "Quindío" },
      { name: "Circasia", state: "Quindío" },
      { name: "Córdoba", state: "Quindío" },
      { name: "Filandia", state: "Quindío" },
      { name: "Génova", state: "Quindío" },
      { name: "La Tebaida", state: "Quindío" },
      { name: "Montenegro", state: "Quindío" },
      { name: "Pijao", state: "Quindío" },
      { name: "Quimbaya", state: "Quindío" },
      { name: "Salento", state: "Quindío" },
      { name: "Apía", state: "Risaralda" },
      { name: "Balboa", state: "Risaralda" },
      { name: "Belén de Umbría", state: "Risaralda" },
      { name: "Dosquebradas", state: "Risaralda" },
      { name: "Guática", state: "Risaralda" },
      { name: "La Celia", state: "Risaralda" },
      { name: "La Virginia", state: "Risaralda" },
      { name: "Marsella", state: "Risaralda" },
      { name: "Mistrató", state: "Risaralda" },
      { name: "Pereira", state: "Risaralda" },
      { name: "Pueblo Rico", state: "Risaralda" },
      { name: "Quinchía", state: "Risaralda" },
      { name: "Santa Rosa de Cabal", state: "Risaralda" },
      { name: "Santuario", state: "Risaralda" },
      { name: "Providencia", state: "San Andrés y Providencia" },
      { name: "Aguada", state: "Santander" },
      { name: "Albania", state: "Santander" },
      { name: "Aratoca", state: "Santander" },
      { name: "Barbosa", state: "Santander" },
      { name: "Barichara", state: "Santander" },
      { name: "Barrancabermeja", state: "Santander" },
      { name: "Betulia", state: "Santander" },
      { name: "Bolívar", state: "Santander" },
      { name: "Bucaramanga", state: "Santander" },
      { name: "Cabrera", state: "Santander" },
      { name: "California", state: "Santander" },
      { name: "Capitanejo", state: "Santander" },
      { name: "Carcasí", state: "Santander" },
      { name: "Cepitá", state: "Santander" },
      { name: "Cerrito", state: "Santander" },
      { name: "Charalá", state: "Santander" },
      { name: "Charta", state: "Santander" },
      { name: "Chima", state: "Santander" },
      { name: "Chipatá", state: "Santander" },
      { name: "Cimitarra", state: "Santander" },
      { name: "Concepción", state: "Santander" },
      { name: "Confines", state: "Santander" },
      { name: "Contratación", state: "Santander" },
      { name: "Coromoro", state: "Santander" },
      { name: "Curití", state: "Santander" },
      { name: "El Carmen de Chucurí", state: "Santander" },
      { name: "El Guacamayo", state: "Santander" },
      { name: "El Peñón", state: "Santander" },
      { name: "El Playón", state: "Santander" },
      { name: "Encino", state: "Santander" },
      { name: "Enciso", state: "Santander" },
      { name: "Florián", state: "Santander" },
      { name: "Floridablanca", state: "Santander" },
      { name: "Galán", state: "Santander" },
      { name: "Gámbita", state: "Santander" },
      { name: "Girón", state: "Santander" },
      { name: "Guaca", state: "Santander" },
      { name: "Guadalupe", state: "Santander" },
      { name: "Guapotá", state: "Santander" },
      { name: "Guavatá", state: "Santander" },
      { name: "Güepsa", state: "Santander" },
      { name: "Hato", state: "Santander" },
      { name: "Jesús María", state: "Santander" },
      { name: "Jordán", state: "Santander" },
      { name: "La Belleza", state: "Santander" },
      { name: "La Paz", state: "Santander" },
      { name: "Landázuri", state: "Santander" },
      { name: "Lebrija", state: "Santander" },
      { name: "Los Santos", state: "Santander" },
      { name: "Macaravita", state: "Santander" },
      { name: "Málaga", state: "Santander" },
      { name: "Matanza", state: "Santander" },
      { name: "Mogotes", state: "Santander" },
      { name: "Molagavita", state: "Santander" },
      { name: "Ocamonte", state: "Santander" },
      { name: "Oiba", state: "Santander" },
      { name: "Onzaga", state: "Santander" },
      { name: "Palmar", state: "Santander" },
      { name: "Palmas del Socorro", state: "Santander" },
      { name: "Páramo", state: "Santander" },
      { name: "Piedecuesta", state: "Santander" },
      { name: "Pinchote", state: "Santander" },
      { name: "Puente Nacional", state: "Santander" },
      { name: "Puerto Parra", state: "Santander" },
      { name: "Puerto Wilches", state: "Santander" },
      { name: "Rionegro", state: "Santander" },
      { name: "Sabana de Torres", state: "Santander" },
      { name: "San Andrés", state: "Santander" },
      { name: "San Benito", state: "Santander" },
      { name: "San Gil", state: "Santander" },
      { name: "San Joaquín", state: "Santander" },
      { name: "San José de Miranda", state: "Santander" },
      { name: "San Miguel", state: "Santander" },
      { name: "San Vicente de Chucurí", state: "Santander" },
      { name: "Santa Bárbara", state: "Santander" },
      { name: "Santa Helena del Opón", state: "Santander" },
      { name: "Simacota", state: "Santander" },
      { name: "Socorro", state: "Santander" },
      { name: "Suaita", state: "Santander" },
      { name: "Sucre", state: "Santander" },
      { name: "Suratá", state: "Santander" },
      { name: "Tona", state: "Santander" },
      { name: "Valle de San José", state: "Santander" },
      { name: "Vélez", state: "Santander" },
      { name: "Vetas", state: "Santander" },
      { name: "Villanueva", state: "Santander" },
      { name: "Zapatoca", state: "Santander" },
      { name: "Guaranda", state: "Sucre" },
      { name: "Majagual", state: "Sucre" },
      { name: "Sucre", state: "Sucre" },
      { name: "Chalán", state: "Sucre" },
      { name: "Colosó", state: "Sucre" },
      { name: "Morroa", state: "Sucre" },
      { name: "Ovejas", state: "Sucre" },
      { name: "Sincelejo", state: "Sucre" },
      { name: "Coveñas", state: "Sucre" },
      { name: "Palmito", state: "Sucre" },
      { name: "San Onofre", state: "Sucre" },
      { name: "Santiago de Tolú", state: "Sucre" },
      { name: "Toluviejo", state: "Sucre" },
      { name: "Buenavista", state: "Sucre" },
      { name: "Corozal", state: "Sucre" },
      { name: "El Roble", state: "Sucre" },
      { name: "Galeras", state: "Sucre" },
      { name: "Los Palmitos", state: "Sucre" },
      { name: "Sampués", state: "Sucre" },
      { name: "San Juan de Betulia", state: "Sucre" },
      { name: "San Pedro", state: "Sucre" },
      { name: "Sincé", state: "Sucre" },
      { name: "Caimito", state: "Sucre" },
      { name: "La Unión", state: "Sucre" },
      { name: "San Benito Abad", state: "Sucre" },
      { name: "San Marcos", state: "Sucre" },
      { name: "Alvarado", state: "Tolima" },
      { name: "Anzoátegui", state: "Tolima" },
      { name: "Cajamarca", state: "Tolima" },
      { name: "Coello", state: "Tolima" },
      { name: "Espinal", state: "Tolima" },
      { name: "Flandes", state: "Tolima" },
      { name: "Ibagué", state: "Tolima" },
      { name: "Piedras", state: "Tolima" },
      { name: "Rovira", state: "Tolima" },
      { name: "San Luis", state: "Tolima" },
      { name: "Valle de San Juan", state: "Tolima" },
      { name: "Casabianca", state: "Tolima" },
      { name: "Herveo", state: "Tolima" },
      { name: "Lérida", state: "Tolima" },
      { name: "Líbano", state: "Tolima" },
      { name: "Murillo", state: "Tolima" },
      { name: "Santa Isabel", state: "Tolima" },
      { name: "Venadillo", state: "Tolima" },
      { name: "Villahermosa", state: "Tolima" },
      { name: "Ambalema", state: "Tolima" },
      { name: "Armero", state: "Tolima" },
      { name: "Falan", state: "Tolima" },
      { name: "Fresno", state: "Tolima" },
      { name: "Honda", state: "Tolima" },
      { name: "Mariquita", state: "Tolima" },
      { name: "Palocabildo", state: "Tolima" },
      { name: "Carmen de Apicalá", state: "Tolima" },
      { name: "Cunday", state: "Tolima" },
      { name: "Icononzo", state: "Tolima" },
      { name: "Melgar", state: "Tolima" },
      { name: "Villarrica", state: "Tolima" },
      { name: "Ataco", state: "Tolima" },
      { name: "Chaparral", state: "Tolima" },
      { name: "Coyaima", state: "Tolima" },
      { name: "Natagaima", state: "Tolima" },
      { name: "Ortega", state: "Tolima" },
      { name: "Planadas", state: "Tolima" },
      { name: "Rioblanco", state: "Tolima" },
      { name: "Roncesvalles", state: "Tolima" },
      { name: "San Antonio", state: "Tolima" },
      { name: "Alpujarra", state: "Tolima" },
      { name: "Dolores", state: "Tolima" },
      { name: "Guamo", state: "Tolima" },
      { name: "Prado", state: "Tolima" },
      { name: "Purificación", state: "Tolima" },
      { name: "Saldaña", state: "Tolima" },
      { name: "Suárez", state: "Tolima" },
      { name: "Alcalá", state: "Valle del Cauca" },
      { name: "Andalucía", state: "Valle del Cauca" },
      { name: "Ansermanuevo", state: "Valle del Cauca" },
      { name: "Argelia", state: "Valle del Cauca" },
      { name: "Bolívar", state: "Valle del Cauca" },
      { name: "Buenaventura", state: "Valle del Cauca" },
      { name: "Buga", state: "Valle del Cauca" },
      { name: "Bugalagrande", state: "Valle del Cauca" },
      { name: "Caicedonia", state: "Valle del Cauca" },
      { name: "Cali", state: "Valle del Cauca" },
      { name: "Calima - El Darién", state: "Valle del Cauca" },
      { name: "Candelaria", state: "Valle del Cauca" },
      { name: "Cartago", state: "Valle del Cauca" },
      { name: "Dagua", state: "Valle del Cauca" },
      { name: "El Águila", state: "Valle del Cauca" },
      { name: "El Cairo", state: "Valle del Cauca" },
      { name: "El Cerrito", state: "Valle del Cauca" },
      { name: "El Dovio", state: "Valle del Cauca" },
      { name: "Florida", state: "Valle del Cauca" },
      { name: "Ginebra", state: "Valle del Cauca" },
      { name: "Guacarí", state: "Valle del Cauca" },
      { name: "Jamundí", state: "Valle del Cauca" },
      { name: "La Cumbre", state: "Valle del Cauca" },
      { name: "La Unión", state: "Valle del Cauca" },
      { name: "La Victoria", state: "Valle del Cauca" },
      { name: "Obando", state: "Valle del Cauca" },
      { name: "Palmira", state: "Valle del Cauca" },
      { name: "Pradera", state: "Valle del Cauca" },
      { name: "Restrepo", state: "Valle del Cauca" },
      { name: "Riofrío", state: "Valle del Cauca" },
      { name: "Roldanillo", state: "Valle del Cauca" },
      { name: "San Pedro", state: "Valle del Cauca" },
      { name: "Sevilla", state: "Valle del Cauca" },
      { name: "Toro", state: "Valle del Cauca" },
      { name: "Trujillo", state: "Valle del Cauca" },
      { name: "Tuluá", state: "Valle del Cauca" },
      { name: "Ulloa", state: "Valle del Cauca" },
      { name: "Versalles", state: "Valle del Cauca" },
      { name: "Vijes", state: "Valle del Cauca" },
      { name: "Yotoco", state: "Valle del Cauca" },
      { name: "Yumbo", state: "Valle del Cauca" },
      { name: "Zarzal", state: "Valle del Cauca" },
      { name: "Carurú", state: "Vaupés" },
      { name: "Mitú", state: "Vaupés" },
      { name: "Taraira", state: "Vaupés" },
      { name: "Cumaribo", state: "Vichada" },
      { name: "La Primavera", state: "Vichada" },
      { name: "Puerto Carreño", state: "Vichada" },
      { name: "Santa Rosalía", state: "Vichada" },
    ],
  },
  EC: {
    states: [
      { name: "Azuay", code: "EC-A", minZip: 0, maxZip: 999999 },
      { name: "Bolívar", code: "EC-B", minZip: 0, maxZip: 999999 },
      { name: "Cañar", code: "EC-F", minZip: 0, maxZip: 999999 },
      { name: "Carchi", code: "EC-C", minZip: 0, maxZip: 999999 },
      { name: "Chimborazo", code: "EC-H", minZip: 0, maxZip: 999999 },
      { name: "Cotopaxi", code: "EC-X", minZip: 0, maxZip: 999999 },
      { name: "El Oro", code: "EC-O", minZip: 0, maxZip: 999999 },
      { name: "Esmeraldas", code: "EC-E", minZip: 0, maxZip: 999999 },
      { name: "Galápagos", code: "EC-W", minZip: 0, maxZip: 999999 },
      { name: "Guayas", code: "EC-G", minZip: 0, maxZip: 999999 },
      { name: "Imbabura", code: "EC-I", minZip: 0, maxZip: 999999 },
      { name: "Loja", code: "EC-L", minZip: 0, maxZip: 999999 },
      { name: "Los Ríos", code: "EC-R", minZip: 0, maxZip: 999999 },
      { name: "Manabí", code: "EC-M", minZip: 0, maxZip: 999999 },
      { name: "Morona Santiago", code: "EC-S", minZip: 0, maxZip: 999999 },
      { name: "Napo", code: "EC-N", minZip: 0, maxZip: 999999 },
      { name: "Orellana", code: "EC-D", minZip: 0, maxZip: 999999 },
      { name: "Pastaza", code: "EC-Y", minZip: 0, maxZip: 999999 },
      { name: "Pichincha", code: "EC-P", minZip: 0, maxZip: 999999 },
      { name: "Santa Elena", code: "EC-SE", minZip: 0, maxZip: 999999 },
      {
        name: "Santo Domingo de los Tsáchilas",
        code: "EC-SD",
        minZip: 0,
        maxZip: 999999,
      },
      { name: "Sucumbíos", code: "EC-U", minZip: 0, maxZip: 999999 },
      { name: "Tungurahua", code: "EC-T", minZip: 0, maxZip: 999999 },
      { name: "Zamora Chinchipe", code: "EC-Z", minZip: 0, maxZip: 999999 },
    ],
    cities: [
      { name: "Cuenca", state: "Azuay" },
      { name: "Gualaceo", state: "Azuay" },
      { name: "Camilo Ponce Enríquez", state: "Azuay" },
      { name: "Paute", state: "Azuay" },
      { name: "Santa Isabel", state: "Azuay" },
      { name: "Chordeleg", state: "Azuay" },
      { name: "Girón", state: "Azuay" },
      { name: "Sígsig", state: "Azuay" },
      { name: "San Fernando", state: "Azuay" },
      { name: "Nabón", state: "Azuay" },
      { name: "Guachapala", state: "Azuay" },
      { name: "Oña", state: "Azuay" },
      { name: "Pucará", state: "Azuay" },
      { name: "Sevilla de Oro", state: "Azuay" },
      { name: "El Pan", state: "Azuay" },
      { name: "Guaranda", state: "Bolívar" },
      { name: "San Miguel", state: "Bolívar" },
      { name: "Caluma", state: "Bolívar" },
      { name: "Echeandía", state: "Bolívar" },
      { name: "Chimbo", state: "Bolívar" },
      { name: "Chillanes", state: "Bolívar" },
      { name: "Las Naves", state: "Bolívar" },
      { name: "La Troncal", state: "Cañar" },
      { name: "Azogues", state: "Cañar" },
      { name: "Cañar", state: "Cañar" },
      { name: "Biblián", state: "Cañar" },
      { name: "El Tambo", state: "Cañar" },
      { name: "Suscal", state: "Cañar" },
      { name: "Déleg", state: "Cañar" },
      { name: "Tulcán", state: "Carchi" },
      { name: "San Gabriel", state: "Carchi" },
      { name: "El Ángel", state: "Carchi" },
      { name: "Huaca", state: "Carchi" },
      { name: "Mira", state: "Carchi" },
      { name: "Bolívar", state: "Carchi" },
      { name: "Riobamba", state: "Chimborazo" },
      { name: "Cumandá", state: "Chimborazo" },
      { name: "Canton Guano", state: "Chimborazo" },
      { name: "Alausí", state: "Chimborazo" },
      { name: "Chambo", state: "Chimborazo" },
      { name: "Pallatanga", state: "Chimborazo" },
      { name: "Chunchi", state: "Chimborazo" },
      { name: "Guamote", state: "Chimborazo" },
      { name: "Villa La Unión (Cajabamba)", state: "Chimborazo" },
      { name: "Penipe", state: "Chimborazo" },
      { name: "Latacunga", state: "Cotopaxi" },
      { name: "La Maná", state: "Cotopaxi" },
      { name: "San Miguel de Salcedo", state: "Cotopaxi" },
      { name: "Pujilí", state: "Cotopaxi" },
      { name: "Saquisilí", state: "Cotopaxi" },
      { name: "Sigchos", state: "Cotopaxi" },
      { name: "El Corazón", state: "Cotopaxi" },
      { name: "Machala", state: "El Oro" },
      { name: "Pasaje", state: "El Oro" },
      { name: "Santa Rosa", state: "El Oro" },
      { name: "Huaquillas", state: "El Oro" },
      { name: "El Guabo", state: "El Oro" },
      { name: "Arenillas", state: "El Oro" },
      { name: "Piñas", state: "El Oro" },
      { name: "Zaruma", state: "El Oro" },
      { name: "Portovelo", state: "El Oro" },
      { name: "Marcabelí", state: "El Oro" },
      { name: "Balsas", state: "El Oro" },
      { name: "Paccha", state: "El Oro" },
      { name: "La Victoria", state: "El Oro" },
      { name: "Chilla", state: "El Oro" },
      { name: "Esmeraldas", state: "Esmeraldas" },
      { name: "Rosa Zárate", state: "Esmeraldas" },
      { name: "San Lorenzo", state: "Esmeraldas" },
      { name: "Atacames", state: "Esmeraldas" },
      { name: "Muisne", state: "Esmeraldas" },
      { name: "Valdez (Limones)", state: "Esmeraldas" },
      { name: "Rioverde", state: "Esmeraldas" },
      { name: "Puerto Ayora", state: "Galápagos" },
      { name: "Puerto Baquerizo Moreno", state: "Galápagos" },
      { name: "Puerto Villamil", state: "Galápagos" },
      { name: "Guayaquil", state: "Guayas" },
      { name: "Durán", state: "Guayas" },
      { name: "Daule", state: "Guayas" },
      { name: "Milagro", state: "Guayas" },
      { name: "Samborondón", state: "Guayas" },
      { name: "General Villamil", state: "Guayas" },
      { name: "Velasco Ibarra", state: "Guayas" },
      { name: "El Triunfo", state: "Guayas" },
      { name: "Naranjal", state: "Guayas" },
      { name: "Naranjito", state: "Guayas" },
      { name: "Balzar", state: "Guayas" },
      { name: "Pedro Carbo", state: "Guayas" },
      { name: "Yaguachi", state: "Guayas" },
      { name: "Lomas de Sargentillo", state: "Guayas" },
      { name: "Salitre", state: "Guayas" },
      { name: "Balao", state: "Guayas" },
      { name: "Santa Lucía", state: "Guayas" },
      { name: "Palestina", state: "Guayas" },
      { name: "Nobol", state: "Guayas" },
      { name: "Simón Bolívar", state: "Guayas" },
      { name: "Isidro Ayora", state: "Guayas" },
      { name: "Cnel. Marcelino Maridueña", state: "Guayas" },
      { name: "Colimes", state: "Guayas" },
      { name: "Gral. Antonio Elizalde (Bucay)", state: "Guayas" },
      { name: "Alfredo Baquerizo Moreno", state: "Guayas" },
      { name: "Ibarra", state: "Imbabura" },
      { name: "Otavalo", state: "Imbabura" },
      { name: "Atuntaqui", state: "Imbabura" },
      { name: "Cotacachi", state: "Imbabura" },
      { name: "Pimampiro", state: "Imbabura" },
      { name: "Urcuquí", state: "Imbabura" },
      { name: "Loja", state: "Loja" },
      { name: "Catamayo", state: "Loja" },
      { name: "Cariamanga", state: "Loja" },
      { name: "Macará", state: "Loja" },
      { name: "Catacocha", state: "Loja" },
      { name: "Alamor", state: "Loja" },
      { name: "Saraguro", state: "Loja" },
      { name: "Celica", state: "Loja" },
      { name: "Zapotillo", state: "Loja" },
      { name: "Pindal", state: "Loja" },
      { name: "Amaluza", state: "Loja" },
      { name: "Gonzanamá", state: "Loja" },
      { name: "Chaguarpamba", state: "Loja" },
      { name: "Quilanga", state: "Loja" },
      { name: "Sozoranga", state: "Loja" },
      { name: "Olmedo", state: "Loja" },
      { name: "Quevedo", state: "Los Ríos" },
      { name: "Babahoyo", state: "Los Ríos" },
      { name: "Buena Fe", state: "Los Ríos" },
      { name: "Ventanas", state: "Los Ríos" },
      { name: "Vinces", state: "Los Ríos" },
      { name: "Valencia", state: "Los Ríos" },
      { name: "Montalvo", state: "Los Ríos" },
      { name: "Puebloviejo", state: "Los Ríos" },
      { name: "Mocache", state: "Los Ríos" },
      { name: "Palenque", state: "Los Ríos" },
      { name: "Catarama", state: "Los Ríos" },
      { name: "Baba", state: "Los Ríos" },
      { name: "Quinsaloma", state: "Los Ríos" },
      { name: "Manta", state: "Manabí" },
      { name: "Portoviejo", state: "Manabí" },
      { name: "Montecristi", state: "Manabí" },
      { name: "Chone", state: "Manabí" },
      { name: "El Carmen", state: "Manabí" },
      { name: "Jipijapa", state: "Manabí" },
      { name: "Jaramijó", state: "Manabí" },
      { name: "Pedernales", state: "Manabí" },
      { name: "Bahía de Caráquez", state: "Manabí" },
      { name: "Calceta", state: "Manabí" },
      { name: "Puerto López", state: "Manabí" },
      { name: "Santa Ana", state: "Manabí" },
      { name: "Rocafuerte", state: "Manabí" },
      { name: "Tosagua", state: "Manabí" },
      { name: "San Vicente", state: "Manabí" },
      { name: "Flavio Alfaro", state: "Manabí" },
      { name: "Paján", state: "Manabí" },
      { name: "Junín", state: "Manabí" },
      { name: "Sucre", state: "Manabí" },
      { name: "Jama", state: "Manabí" },
      { name: "Pichincha", state: "Manabí" },
      { name: "Olmedo", state: "Manabí" },
      { name: "Macas", state: "Morona Santiago" },
      { name: "Sucúa", state: "Morona Santiago" },
      { name: "Gualaquiza", state: "Morona Santiago" },
      { name: "Palora", state: "Morona Santiago" },
      {
        name: "Gral. Leonidas Plaza Gutiérrez (Limón)",
        state: "Morona Santiago",
      },
      { name: "Santiago de Méndez", state: "Morona Santiago" },
      { name: "Taisha", state: "Morona Santiago" },
      { name: "San Juan Bosco", state: "Morona Santiago" },
      { name: "Logroño", state: "Morona Santiago" },
      { name: "Huamboya", state: "Morona Santiago" },
      { name: "Santiago", state: "Morona Santiago" },
      { name: "Pablo Sexto", state: "Morona Santiago" },
      { name: "Tena", state: "Napo" },
      { name: "Archidona", state: "Napo" },
      { name: "El Chaco", state: "Napo" },
      { name: "Baeza", state: "Napo" },
      { name: "Carlos Julio Arosemena Tola", state: "Napo" },
      { name: "El Coca", state: "Orellana" },
      { name: "La Joya de los Sachas", state: "Orellana" },
      { name: "Loreto", state: "Orellana" },
      { name: "Tiputini", state: "Orellana" },
      { name: "Puyo", state: "Pastaza" },
      { name: "Arajuno", state: "Pastaza" },
      { name: "Santa Clara", state: "Pastaza" },
      { name: "Mera", state: "Pastaza" },
      { name: "Quito", state: "Pichincha" },
      { name: "Sangolquí", state: "Pichincha" },
      { name: "Cayambe", state: "Pichincha" },
      { name: "Machachi", state: "Pichincha" },
      { name: "Tabacundo", state: "Pichincha" },
      { name: "Pedro Vicente Maldonado", state: "Pichincha" },
      { name: "San Miguel de Los Bancos", state: "Pichincha" },
      { name: "Puerto Quito", state: "Pichincha" },
      { name: "La Libertad", state: "Santa Elena" },
      { name: "Santa Elena", state: "Santa Elena" },
      { name: "Salinas", state: "Santa Elena" },
      { name: "Santo Domingo", state: "Santo Domingo de los Tsáchilas" },
      { name: "La Concordia", state: "Santo Domingo de los Tsáchilas" },
      { name: "Nueva Loja", state: "Sucumbíos" },
      { name: "Shushufindi", state: "Sucumbíos" },
      { name: "El Dorado de Cascales", state: "Sucumbíos" },
      { name: "Lumbaqui", state: "Sucumbíos" },
      { name: "Puerto El Carmen de Putumayo", state: "Sucumbíos" },
      { name: "Tarapoa", state: "Sucumbíos" },
      { name: "La Bonita", state: "Sucumbíos" },
      { name: "Ambato", state: "Tungurahua" },
      { name: "Baños de Agua Santa", state: "Tungurahua" },
      { name: "Pelileo", state: "Tungurahua" },
      { name: "Píllaro", state: "Tungurahua" },
      { name: "Cevallos", state: "Tungurahua" },
      { name: "Quero", state: "Tungurahua" },
      { name: "Patate", state: "Tungurahua" },
      { name: "Tisaleo", state: "Tungurahua" },
      { name: "Mocha", state: "Tungurahua" },
      { name: "Zamora", state: "Zamora Chinchipe" },
      { name: "Yantzaza", state: "Zamora Chinchipe" },
      { name: "El Pangui", state: "Zamora Chinchipe" },
      { name: "Zumba", state: "Zamora Chinchipe" },
      { name: "Zumbi", state: "Zamora Chinchipe" },
      { name: "Guayzimi", state: "Zamora Chinchipe" },
      { name: "Palanda", state: "Zamora Chinchipe" },
      { name: "Yacuambi", state: "Zamora Chinchipe" },
      { name: "Paquisha", state: "Zamora Chinchipe" },
    ],
  },
  ID: {
    states: [
      { name: "Aceh", code: "AC" },
      { name: "Bali", code: "BA" },
      { name: "Banten", code: "BT" },
      { name: "Bengkulu", code: "BE" },
      { name: "Gorontalo", code: "GO" },
      { name: "Jakarta", code: "JK" },
      { name: "Jambi", code: "JA" },
      { name: "Jawa Barat", code: "JB" },
      { name: "Jawa Tengah", code: "JT" },
      { name: "Jawa Timur", code: "JI" },
      { name: "Kalimantan Barat", code: "KB" },
      { name: "Kalimantan Selatan", code: "KS" },
      { name: "Kalimantan Tengah", code: "KT" },
      { name: "Kalimantan Timur", code: "KI" },
      { name: "Kalimantan Utara", code: "KU" },
      { name: "Kepulauan Bangka Belitung", code: "BB" },
      { name: "Kepulauan Riau", code: "KR" },
      { name: "Lampung", code: "LA" },
      { name: "Maluku", code: "MA" },
      { name: "Maluku Utara", code: "MU" },
      { name: "Nusa Tenggara Barat", code: "NB" },
      { name: "Nusa Tenggara Timur", code: "NT" },
      { name: "Papua", code: "PA" },
      { name: "Papua Barat", code: "PB" },
      { name: "Riau", code: "RI" },
      { name: "Sulawesi Barat", code: "SR" },
      { name: "Sulawesi Selatan", code: "SN" },
      { name: "Sulawesi Tengah", code: "ST" },
      { name: "Sulawesi Tenggara", code: "SG" },
      { name: "Sulawesi Utara", code: "SA" },
      { name: "Sumatera Barat", code: "SB" },
      { name: "Sumatera Selatan", code: "SS" },
      { name: "Sumatera Utara", code: "SU" },
      { name: "Yogyakarta", code: "YO" },
    ],
    cities: [],
  },
  IN: {
    states: [
      {
        name: "Andaman and Nicobar Islands",
        code: "AN",
        minZip: 744100,
        maxZip: 744300,
      },
      { name: "Andhra Pradesh", code: "AP", minZip: 510000, maxZip: 539999 },
      {
        name: "Arunachal Pradesh",
        code: "AR",
        minZip: 790000,
        maxZip: 799999,
      },
      { name: "Assam", code: "AS", minZip: 780000, maxZip: 789999 },
      { name: "Bihar", code: "BR", minZip: 800000, maxZip: 859999 },
      { name: "Chandigarh", code: "CH", minZip: 160000, maxZip: 169999 },
      { name: "Chhattisgarh", code: "CT", minZip: 490000, maxZip: 499999 },
      {
        name: "Dadra and Nagar Haveli",
        code: "DN",
        minZip: 396000,
        maxZip: 396999,
      },
      { name: "Daman and Diu", code: "DD", minZip: 396210, maxZip: 396210 },
      { name: "Delhi", code: "DL", minZip: 110000, maxZip: 119999 },
      { name: "Goa", code: "GA", minZip: 403000, maxZip: 403999 },
      { name: "Gujarat", code: "GJ", minZip: 360000, maxZip: 399999 },
      { name: "Haryana", code: "HR", minZip: 120000, maxZip: 139999 },
      {
        name: "Himachal Pradesh",
        code: "HP",
        minZip: 170000,
        maxZip: 179999,
      },
      {
        name: "Jammu and Kashmir",
        code: "JK",
        minZip: 180000,
        maxZip: 199999,
      },
      { name: "Jharkhand", code: "JH", minZip: 800000, maxZip: 859999 },
      { name: "Karnataka", code: "KA", minZip: 560000, maxZip: 599999 },
      { name: "Kerala", code: "KL", minZip: 670000, maxZip: 699999 },
      { name: "Lakshadweep", code: "LD", minZip: 682000, maxZip: 682999 },
      { name: "Madhya Pradesh", code: "MP", minZip: 450000, maxZip: 489999 },
      { name: "Maharashtra", code: "MH", minZip: 400000, maxZip: 449999 },
      { name: "Manipur", code: "MN", minZip: 795000, maxZip: 795999 },
      { name: "Meghalaya", code: "ML", minZip: 793000, maxZip: 793999 },
      { name: "Mizoram", code: "MZ", minZip: 796000, maxZip: 796999 },
      { name: "Nagaland", code: "NL", minZip: 797000, maxZip: 797999 },
      { name: "Odisha", code: "OR", minZip: 750000, maxZip: 779999 },
      { name: "Puducherry", code: "PY", minZip: 605000, maxZip: 605999 },
      { name: "Punjab", code: "PB", minZip: 140000, maxZip: 159999 },
      { name: "Rajasthan", code: "RJ", minZip: 300000, maxZip: 349999 },
      { name: "Sikkim", code: "SK", minZip: 737000, maxZip: 737999 },
      { name: "Tamil Nadu", code: "TN", minZip: 600000, maxZip: 669999 },
      { name: "Telangana", code: "TG", minZip: 500000, maxZip: 509999 },
      { name: "Tripura", code: "TR", minZip: 799000, maxZip: 799999 },
      { name: "Uttar Pradesh", code: "UP", minZip: 200000, maxZip: 289999 },
      { name: "Uttarakhand", code: "UT", minZip: 200000, maxZip: 289999 },
      { name: "West Bengal", code: "WB", minZip: 700000, maxZip: 749999 },
    ],
    cities: [],
  },
  MX: {
    states: [
      { name: "Aguascalientes", code: "AGS", minZip: 20000, maxZip: 20999 },
      { name: "Baja California", code: "BC", minZip: 21000, maxZip: 22999 },
      {
        name: "Baja California Sur",
        code: "BCS",
        minZip: 23000,
        maxZip: 23999,
      },
      { name: "Campeche", code: "CAMP", minZip: 24000, maxZip: 24999 },
      { name: "Coahuila", code: "COAH", minZip: 25000, maxZip: 27999 },
      { name: "Colima", code: "COL", minZip: 28000, maxZip: 28999 },
      { name: "Chiapas", code: "CHIS", minZip: 29000, maxZip: 30999 },
      { name: "Chihuahua", code: "CHIH", minZip: 31000, maxZip: 33999 },
      { name: "Ciudad de México", code: "CDMX", minZip: 1000, maxZip: 16999 },
      { name: "Durango", code: "DGO", minZip: 34000, maxZip: 35999 },
      { name: "Guanajuato", code: "GTO", minZip: 36000, maxZip: 38999 },
      { name: "Guerrero", code: "GRO", minZip: 39000, maxZip: 41999 },
      { name: "Hidalgo", code: "HGO", minZip: 42000, maxZip: 43999 },
      { name: "Jalisco", code: "JAL", minZip: 44000, maxZip: 49999 },
      { name: "Estado de México", code: "MEX", minZip: 50000, maxZip: 57999 },
      { name: "Michoacán", code: "MICH", minZip: 58000, maxZip: 61999 },
      { name: "Morelos", code: "MOR", minZip: 62000, maxZip: 62999 },
      { name: "Nayarit", code: "NAY", minZip: 63000, maxZip: 63999 },
      { name: "Nuevo León", code: "NL", minZip: 64000, maxZip: 67999 },
      { name: "Oaxaca", code: "OAX", minZip: 68000, maxZip: 71999 },
      { name: "Puebla", code: "PUE", minZip: 72000, maxZip: 75999 },
      { name: "Querétaro", code: "QRO", minZip: 76000, maxZip: 76999 },
      { name: "Quintana Roo", code: "QROO", minZip: 77000, maxZip: 77999 },
      { name: "San Luis Potosí", code: "SLP", minZip: 78000, maxZip: 79999 },
      { name: "Sinaloa", code: "SIN", minZip: 80000, maxZip: 82999 },
      { name: "Sonora", code: "SON", minZip: 83000, maxZip: 85999 },
      { name: "Tabasco", code: "TAB", minZip: 86000, maxZip: 86999 },
      { name: "Tamaulipas", code: "TAMP", minZip: 87000, maxZip: 89999 },
      { name: "Tlaxcala", code: "TLAX", minZip: 90000, maxZip: 90999 },
      { name: "Veracruz", code: "VER", minZip: 91000, maxZip: 96999 },
      { name: "Yucatán", code: "YUC", minZip: 97000, maxZip: 97999 },
      { name: "Zacatecas", code: "ZAC", minZip: 98000, maxZip: 99999 },
    ],
    cities: [],
  },
  PE: {
    states: [
      { name: "Amazonas", code: "PE-AMA", minZip: 0, maxZip: 999999 },
      { name: "Ancash", code: "PE-ANC", minZip: 0, maxZip: 999999 },
      { name: "Apurímac", code: "PE-APU", minZip: 0, maxZip: 999999 },
      { name: "Arequipa", code: "PE-ARE", minZip: 0, maxZip: 999999 },
      { name: "Ayacucho", code: "PE-AYA", minZip: 0, maxZip: 999999 },
      { name: "Cajamarca", code: "PE-CAJ", minZip: 0, maxZip: 999999 },
      { name: "Callao", code: "PE-CAL", minZip: 0, maxZip: 999999 },
      { name: "Cusco", code: "PE-CUS", minZip: 0, maxZip: 999999 },
      { name: "Huancavelica", code: "PE-HUV", minZip: 0, maxZip: 999999 },
      { name: "Huánuco", code: "PE-HUC", minZip: 0, maxZip: 999999 },
      { name: "Ica", code: "PE-ICA", minZip: 0, maxZip: 999999 },
      { name: "Junín", code: "PE-JUN", minZip: 0, maxZip: 999999 },
      { name: "La Libertad", code: "PE-LAL", minZip: 0, maxZip: 999999 },
      { name: "Lambayeque", code: "PE-LAM", minZip: 0, maxZip: 999999 },
      { name: "Lima", code: "PE-LIM", minZip: 0, maxZip: 999999 },
      { name: "Loreto", code: "PE-LOR", minZip: 0, maxZip: 999999 },
      { name: "Madre de Dios", code: "PE-MDD", minZip: 0, maxZip: 999999 },
      { name: "Moquegua", code: "PE-MOQ", minZip: 0, maxZip: 999999 },
      { name: "Pasco", code: "PE-PAS	19", minZip: 0, maxZip: 999999 },
      { name: "Piura", code: "PE-PIU	20", minZip: 0, maxZip: 999999 },
      { name: "Puno", code: "PE-PUN	21", minZip: 0, maxZip: 999999 },
      { name: "San Martín", code: "PE-SAM", minZip: 0, maxZip: 999999 },
      { name: "Tacna", code: "PE-TAC", minZip: 0, maxZip: 999999 },
      { name: "Tumbes", code: "PE-TUM", minZip: 0, maxZip: 999999 },
      { name: "Ucayali", code: "PE-UCA", minZip: 0, maxZip: 999999 },
    ],
    cities: [],
  },
  PA: {
    states: [
      { name: "Bocas del Toro", code: "PA-1", minZip: 0, maxZip: 999999 },
      { name: "Chiriquí", code: "PA-4", minZip: 0, maxZip: 999999 },
      { name: "Coclé", code: "PA-2", minZip: 0, maxZip: 999999 },
      { name: "Colón", code: "PA-3", minZip: 0, maxZip: 999999 },
      { name: "Darién", code: "PA-5", minZip: 0, maxZip: 999999 },
      { name: "Emberá", code: "PA-EM", minZip: 0, maxZip: 999999 },
      { name: "Guna Yala", code: "PA-KY", minZip: 0, maxZip: 999999 },
      { name: "Herrera", code: "PA-6", minZip: 0, maxZip: 999999 },
      { name: "Los Santos", code: "PA-7", minZip: 0, maxZip: 999999 },
      { name: "Naso Tjër Di", code: "PA-NT", minZip: 0, maxZip: 999999 },
      { name: "Ngäbe-Buglé", code: "PA-NB", minZip: 0, maxZip: 999999 },
      { name: "Panamá", code: "PA-8", minZip: 0, maxZip: 999999 },
      { name: "Panamá Oeste", code: "PA-10", minZip: 0, maxZip: 999999 },
      { name: "Veraguas", code: "PA-9", minZip: 0, maxZip: 999999 },
    ],
    cities: [
      { name: "Panama City", state: "Panamá" },
      { name: "San Miguelito", state: "Panamá" },
      { name: "Colón", state: "Colón" },
      { name: "David", state: "Chiriquí" },
      { name: "Tocumen", state: "Panamá" },
      { name: "La Chorrera", state: "Panamá Oeste" },
      { name: "Balboa Heights", state: "Panamá" },
      { name: "Chilibre", state: "Panamá" },
      { name: "Pacora", state: "Panamá" },
      { name: "Aguadulce", state: "Coclé" },
      { name: "Chitré", state: "Herrera" },
      { name: "Santiago", state: "Veraguas" },
      { name: "Alcalde Díaz", state: "Panamá" },
      { name: "Arraiján", state: "Panamá Oeste" },
      { name: "Cativá", state: "Colón" },
      { name: "Kusapín", state: "Ngäbe-Buglé" },
      { name: "Changuinola", state: "Bocas del Toro" },
      { name: "Ancón", state: "Panamá" },
      { name: "Penonomé", state: "Coclé" },
      { name: "Nuevo Arraiján", state: "Panamá Oeste" },
      { name: "Chepo", state: "Panamá" },
      { name: "Puerto Armuelles", state: "Chiriquí" },
      { name: "El Coco", state: "Panamá Oeste" },
      { name: "Sabanitas", state: "Colón" },
      { name: "Bajo Boquete", state: "Chiriquí" },
      { name: "Puerto Caimito", state: "Panamá Oeste" },
      { name: "Puerto Pilón", state: "Colón" },
      { name: "Bocas del Toro", state: "Bocas del Toro" },
      { name: "Almirante", state: "Bocas del Toro" },
      { name: "Las Tablas", state: "Los Santos" },
      { name: "Paso Canoas", state: "Chiriquí" },
      { name: "Guararé", state: "Los Santos" },
      { name: "Guabito", state: "Bocas del Toro" },
      { name: "Metetí", state: "Darién" },
      { name: "Ocú", state: "Herrera" },
      { name: "Santa Fé", state: "Darién" },
      { name: "Natá", state: "Coclé" },
      { name: "La Mitra", state: "Panamá Oeste" },
      { name: "Lídice", state: "Panamá Oeste" },
      { name: "Capira", state: "Panamá Oeste" },
      { name: "Portobelo", state: "Colón" },
      { name: "Yaviza", state: "Darién" },
      { name: "La Palma", state: "Darién" },
      { name: "Nueva Gorgona", state: "Panamá Oeste" },
      { name: "Río Alejandro Arriba", state: "Colón" },
      { name: "Parita", state: "Herrera" },
      { name: "San Carlos", state: "Panamá Oeste" },
      { name: "Coclé del Norte", state: "Colón" },
      { name: "Santa Fe", state: "Veraguas" },
      { name: "Macaracas", state: "Los Santos" },
      { name: "Tierra Oscura", state: "Bocas del Toro" },
      { name: "Pesé", state: "Herrera" },
      { name: "Calobre", state: "Veraguas" },
      { name: "Chame", state: "Panamá Oeste" },
      { name: "María Chiquita", state: "Colón" },
      { name: "Nuevo Vigía", state: "Colón" },
      { name: "Pedasí", state: "Los Santos" },
      { name: "Escobal", state: "Colón" },
      { name: "Jaqué", state: "Darién" },
      { name: "Miguel de La Borda", state: "Colón" },
      { name: "Tonosí", state: "Los Santos" },
      { name: "Los Pozos", state: "Herrera" },
      { name: "Santa Rita Arriba", state: "Colón" },
      { name: "Bastimentos", state: "Bocas del Toro" },
      { name: "Garachiné", state: "Darién" },
      { name: "La Loma", state: "Coclé" },
      { name: "Palmas Bellas", state: "Colón" },
      { name: "Ailigandí", state: "Guna Yala" },
      { name: "Finca Blanco", state: "Chiriquí" },
      { name: "Llano de Piedra", state: "Los Santos" },
      { name: "Punta Laurel", state: "Bocas del Toro" },
      { name: "Nuevo San Juan", state: "Colón" },
      { name: "Churuquita Chiquita", state: "Coclé" },
      { name: "Chiriquí Grande", state: "Bocas del Toro" },
      { name: "Chimán", state: "Panamá" },
      { name: "Coclecito", state: "Colón" },
      { name: "Tucutí", state: "Darién" },
      { name: "Tubualá", state: "Guna Yala" },
      { name: "El Real", state: "Darién" },
      { name: "Boca de Cupé", state: "Darién" },
      { name: "Potrerillos Arriba", state: "Chiriquí" },
      { name: "Nombre de Dios", state: "Colón" },
      { name: "Puerto Piña", state: "Darién" },
      { name: "Santa Ana Arriba", state: "Los Santos" },
      { name: "Bisira", state: "Ngäbe-Buglé" },
      { name: "Pocrí", state: "Los Santos" },
      { name: "Sambú", state: "Darién" },
      { name: "Kankintú", state: "Ngäbe-Buglé" },
      { name: "Chepigana", state: "Darién" },
      { name: "Brujas", state: "Panamá" },
      { name: "Setegantí", state: "Darién" },
      { name: "Nuevo Chagres", state: "Colón" },
      { name: "Cuango", state: "Colón" },
      { name: "Buabidi", state: "Ngäbe-Buglé" },
      { name: "Palmira", state: "Colón" },
      { name: "Santa Isabel", state: "Colón" },
      { name: "Yape", state: "Emberá" },
      { name: "Playa Chiquita", state: "Colón" },
      { name: "Gonzalo Vásquez", state: "Panamá" },
      { name: "Gaigirgordub", state: "Guna Yala" },
      { name: "San Felipe", state: "Panamá" },
      { name: "Calidonia", state: "Panamá" },
      { name: "San Francisco", state: "Panamá" },
      { name: "Bella Vista", state: "Panamá" },
      { name: "Betania", state: "Panamá" },
      { name: "Vista Alegre", state: "Panamá Oeste" },
      { name: "Arco Iris", state: "Colón" },
      { name: "Sieyik", state: "Naso Tjër Di" },
      { name: "Unión Chocó", state: "Emberá" },
      { name: "Guadalupe", state: "Panamá Oeste" },
      { name: "San Juan Bautista", state: "Herrera" },
      { name: "Cerro Silvestre", state: "Panamá Oeste" },
      { name: "Llano Bonito", state: "Herrera" },
      { name: "Canto del Llano", state: "Veraguas" },
      { name: "Burunga", state: "Panamá Oeste" },
      { name: "Pocrí", state: "Coclé" },
      { name: "Monagrillo", state: "Herrera" },
      { name: "El Chorrillo", state: "Panamá" },
      { name: "San Antonio", state: "Veraguas" },
      { name: "Veracruz", state: "Panamá Oeste" },
      { name: "Las Palmitas", state: "Los Santos" },
      { name: "La Concepción", state: "Chiriquí" },
      { name: "Nueva Providencia", state: "Colón" },
      { name: "Bugaba", state: "Chiriquí" },
      { name: "La Tiza", state: "Los Santos" },
      { name: "Las Lomas", state: "Chiriquí" },
      { name: "El Cocal", state: "Los Santos" },
      { name: "Chepillo", state: "Panamá" },
      { name: "Lajero", state: "Ngäbe-Buglé" },
      { name: "El Sesteadero", state: "Los Santos" },
      { name: "Villa Carmen", state: "Panamá Oeste" },
      { name: "Cabecera de Cerro Puerco", state: "Ngäbe-Buglé" },
      { name: "La Arena", state: "Herrera" },
      { name: "Pedregal", state: "Chiriquí" },
      { name: "La Laja", state: "Los Santos" },
      { name: "El Valle", state: "Coclé" },
      { name: "Progreso", state: "Chiriquí" },
      { name: "Playa Leona", state: "Panamá Oeste" },
      { name: "Los Anastacios", state: "Chiriquí" },
      { name: "Llano Largo", state: "Los Santos" },
      { name: "Alto Caballero", state: "Ngäbe-Buglé" },
      { name: "Otoque Occidente", state: "Panamá" },
      { name: "Curundú", state: "Panamá" },
      { name: "Cerro Iglesia", state: "Ngäbe-Buglé" },
      { name: "San Pablo Viejo Abajo", state: "Chiriquí" },
      { name: "Hato Julí", state: "Ngäbe-Buglé" },
      { name: "Los Naranjos", state: "Chiriquí" },
      { name: "Quebrada de Loro", state: "Ngäbe-Buglé" },
      { name: "Villa Rosario", state: "Panamá Oeste" },
      { name: "Los Santos", state: "Los Santos" },
      { name: "Soná", state: "Veraguas" },
      { name: "Río Hato", state: "Coclé" },
      { name: "El Espino", state: "Panamá Oeste" },
      { name: "Margarita", state: "Colón" },
      { name: "Piña", state: "Colón" },
      { name: "Buena Vista", state: "Colón" },
      { name: "Salto Dupí", state: "Ngäbe-Buglé" },
      { name: "Maraca", state: "Ngäbe-Buglé" },
      { name: "La Palma", state: "Los Santos" },
      { name: "Chacarero", state: "Chiriquí" },
      { name: "Cañaveral", state: "Coclé" },
      { name: "Bejuco", state: "Panamá Oeste" },
      { name: "Aserrío de Gariché", state: "Chiriquí" },
      { name: "Punta Peña", state: "Bocas del Toro" },
      { name: "Pueblo Nuevo", state: "Ngäbe-Buglé" },
      { name: "Dolega", state: "Chiriquí" },
      { name: "Hato Corotú", state: "Ngäbe-Buglé" },
      { name: "Oma", state: "Ngäbe-Buglé" },
      { name: "Alanje", state: "Chiriquí" },
      { name: "Sajalices", state: "Panamá Oeste" },
      { name: "La Esperanza", state: "Chiriquí" },
      { name: "Antón", state: "Coclé" },
      { name: "San José", state: "Panamá Oeste" },
      { name: "Las Lajas", state: "Panamá Oeste" },
      { name: "Santa Marta", state: "Chiriquí" },
      { name: "Boquerón", state: "Chiriquí" },
      { name: "Las Uvas", state: "Panamá Oeste" },
      { name: "Llano Abajo", state: "Los Santos" },
      { name: "La Estrella", state: "Chiriquí" },
      { name: "Caballero", state: "Coclé" },
      { name: "Marica de Antón", state: "Coclé" },
      { name: "Taboga", state: "Panamá" },
      { name: "Río Sereno", state: "Chiriquí" },
      { name: "Atalaya", state: "Veraguas" },
      { name: "Dos Ríos", state: "Chiriquí" },
      { name: "Chichica", state: "Ngäbe-Buglé" },
      { name: "Contadora", state: "Panamá" },
      { name: "Saboga", state: "Panamá" },
      { name: "San Carlos", state: "Chiriquí" },
      { name: "Sortová", state: "Chiriquí" },
      { name: "Cañas Gordas", state: "Chiriquí" },
      { name: "Los Algarrobos", state: "Veraguas" },
      { name: "La Peña", state: "Veraguas" },
      { name: "Limón", state: "Colón" },
      { name: "La Enea", state: "Los Santos" },
      { name: "Camarón Arriba", state: "Ngäbe-Buglé" },
      { name: "Tijeras", state: "Chiriquí" },
      { name: "Cerro Viejo", state: "Chiriquí" },
      { name: "Llano Grande", state: "Coclé" },
      { name: "Rambala", state: "Bocas del Toro" },
      { name: "El Higo", state: "Panamá Oeste" },
      { name: "Alto Boquete", state: "Chiriquí" },
      { name: "Peña Blanca", state: "Los Santos" },
      { name: "Gómez", state: "Chiriquí" },
      { name: "Santa Rita", state: "Coclé" },
      { name: "Cerro Punta", state: "Chiriquí" },
      { name: "Las Guabas", state: "Herrera" },
      { name: "La Montañuela", state: "Veraguas" },
      { name: "Cochea Abajo", state: "Chiriquí" },
      { name: "Los Olivos", state: "Los Santos" },
      { name: "Volcán", state: "Chiriquí" },
      { name: "Monte Lirio", state: "Chiriquí" },
      { name: "Santa Rita", state: "Panamá Oeste" },
      { name: "Hato Jobo", state: "Ngäbe-Buglé" },
      { name: "Hato Pilón", state: "Ngäbe-Buglé" },
      { name: "San Félix", state: "Chiriquí" },
      { name: "Los Llanitos", state: "Panamá Oeste" },
      { name: "Cerro Caña", state: "Ngäbe-Buglé" },
      { name: "Otoque Oriente", state: "Panamá" },
      { name: "La Ermita", state: "Panamá Oeste" },
      { name: "El Manantial", state: "Los Santos" },
      { name: "El Espino", state: "Panamá Oeste" },
      { name: "Buenos Aires", state: "Panamá Oeste" },
      { name: "Cañazas", state: "Veraguas" },
      { name: "Tinajas", state: "Chiriquí" },
      { name: "Bágala", state: "Chiriquí" },
      { name: "La Cabuya", state: "Herrera" },
      { name: "Llano Culebra", state: "Chiriquí" },
      { name: "Sabana Grande", state: "Los Santos" },
      { name: "El Tejar", state: "Chiriquí" },
      { name: "El Limón", state: "Herrera" },
      { name: "Capellanía", state: "Coclé" },
      { name: "Jaramillo Arriba", state: "Chiriquí" },
      { name: "Sitio Prado", state: "Ngäbe-Buglé" },
      { name: "Las Ollas Arriba", state: "Panamá Oeste" },
      { name: "Agua Buena", state: "Los Santos" },
      { name: "Tres Quebradas", state: "Los Santos" },
      { name: "Pilón", state: "Veraguas" },
      { name: "Bahía Azul", state: "Ngäbe-Buglé" },
      { name: "El Roble", state: "Coclé" },
      { name: "Chupampa", state: "Herrera" },
      { name: "Chiguirí Arriba", state: "Coclé" },
      { name: "Querévalo", state: "Chiriquí" },
      { name: "Cabuya", state: "Coclé" },
      { name: "La Pasera", state: "Los Santos" },
      { name: "Llano Ñopo", state: "Ngäbe-Buglé" },
      { name: "Guararé Arriba", state: "Los Santos" },
      { name: "Isla Grande", state: "Colón" },
      { name: "Potrerillos Abajo", state: "Chiriquí" },
      { name: "La Espigadilla", state: "Los Santos" },
      { name: "El Carate", state: "Los Santos" },
      { name: "El Potrero", state: "Coclé" },
      { name: "Cerro Venado", state: "Ngäbe-Buglé" },
      { name: "El Rincón", state: "Herrera" },
      { name: "Miramar", state: "Bocas del Toro" },
      { name: "El Retiro", state: "Coclé" },
      { name: "Cerro Banco", state: "Ngäbe-Buglé" },
      { name: "Santa Clara", state: "Panamá Oeste" },
      { name: "Cabuya", state: "Panamá Oeste" },
      { name: "Montijo", state: "Veraguas" },
      { name: "El Barrero", state: "Herrera" },
      { name: "Chupá", state: "Los Santos" },
      { name: "El Caño", state: "Coclé" },
      { name: "La Pintada", state: "Coclé" },
      { name: "Chicá", state: "Panamá Oeste" },
      { name: "San Juan", state: "Veraguas" },
      { name: "Soloy", state: "Ngäbe-Buglé" },
      { name: "Los Cerritos", state: "Herrera" },
      { name: "San Andrés", state: "Chiriquí" },
      { name: "Santo Domingo", state: "Chiriquí" },
      { name: "Tolé", state: "Chiriquí" },
      { name: "Guabal", state: "Chiriquí" },
      { name: "La Colorada", state: "Los Santos" },
      { name: "Santo Domingo", state: "Los Santos" },
      { name: "Rincón Hondo", state: "Herrera" },
      { name: "Río Congo", state: "Panamá Oeste" },
      { name: "Caimito", state: "Panamá Oeste" },
      { name: "Los Ángeles", state: "Los Santos" },
      { name: "Divalá", state: "Chiriquí" },
      { name: "La Mesa", state: "Panamá" },
      { name: "Cacique", state: "Colón" },
      { name: "El Chirú", state: "Coclé" },
      { name: "Rovira Arriba", state: "Chiriquí" },
      { name: "Cuipo", state: "Colón" },
      { name: "Las Lajas", state: "Chiriquí" },
      { name: "Paraíso", state: "Chiriquí" },
      { name: "Guayabal", state: "Chiriquí" },
      { name: "Hato Culantro", state: "Ngäbe-Buglé" },
      { name: "El Cristo", state: "Coclé" },
      { name: "Nuevo Emperador", state: "Panamá Oeste" },
      { name: "Mirones", state: "Ngäbe-Buglé" },
      { name: "Garrote", state: "Colón" },
      { name: "Santa María", state: "Herrera" },
      { name: "El Coco", state: "Coclé" },
      { name: "El Espinal", state: "Los Santos" },
      { name: "Veladero", state: "Chiriquí" },
      { name: "Los Canelos", state: "Herrera" },
      { name: "San Pedro del Espino", state: "Veraguas" },
      { name: "El Hato", state: "Los Santos" },
      { name: "Santo Tomás", state: "Chiriquí" },
      { name: "La Colorada", state: "Veraguas" },
      { name: "El Puerto", state: "Chiriquí" },
      { name: "Juan Díaz", state: "Coclé" },
      { name: "Santa Rosa", state: "Chiriquí" },
      { name: "Coclé", state: "Coclé" },
      { name: "El Rincón", state: "Veraguas" },
      { name: "Villa Lourdes", state: "Los Santos" },
      { name: "El Capurí", state: "Herrera" },
      { name: "El Piro", state: "Ngäbe-Buglé" },
      { name: "Peña Blanca", state: "Ngäbe-Buglé" },
      { name: "Zangüengas", state: "Panamá Oeste" },
      { name: "El Barrito", state: "Veraguas" },
      { name: "Plaza de Caisán", state: "Chiriquí" },
      { name: "Campana", state: "Panamá Oeste" },
      { name: "Río Grande", state: "Coclé" },
      { name: "Tobobe", state: "Ngäbe-Buglé" },
      { name: "El Pájaro", state: "Herrera" },
      { name: "Guarumal", state: "Chiriquí" },
      { name: "Piedras Gordas", state: "Coclé" },
      { name: "Calabacito", state: "Veraguas" },
      { name: "Sabana Grande", state: "Herrera" },
      { name: "Punta Chame", state: "Panamá Oeste" },
      { name: "El Cacao", state: "Panamá Oeste" },
      { name: "La Raya de Santa María", state: "Veraguas" },
      { name: "Portobelillo", state: "Herrera" },
      { name: "San Francisco", state: "Veraguas" },
      { name: "Las Cabras", state: "Herrera" },
      { name: "Cerro Iglesia", state: "Chiriquí" },
      { name: "Buenos Aires", state: "Ngäbe-Buglé" },
      { name: "Boca de Balsa", state: "Ngäbe-Buglé" },
      { name: "Santa Lucía", state: "Chiriquí" },
      { name: "Remedios", state: "Chiriquí" },
      { name: "Santa Cruz", state: "Chiriquí" },
      { name: "Guayabito", state: "Ngäbe-Buglé" },
      { name: "Llano de La Cruz", state: "Herrera" },
      { name: "Las Guabas", state: "Los Santos" },
      { name: "Palmira Centro", state: "Chiriquí" },
      { name: "El Pedregoso", state: "Herrera" },
      { name: "El Guabo", state: "Colón" },
      { name: "La Arena", state: "Herrera" },
      { name: "Agua de Salud", state: "Ngäbe-Buglé" },
      { name: "Alto de Jesús", state: "Ngäbe-Buglé" },
      { name: "Ciricito Abajo", state: "Panamá Oeste" },
      { name: "Los Castillos", state: "Herrera" },
      { name: "Guacá Arriba", state: "Chiriquí" },
      { name: "Potuga", state: "Herrera" },
      { name: "Cabuya", state: "Herrera" },
      { name: "El Nancito", state: "Chiriquí" },
      { name: "Gualaca", state: "Chiriquí" },
      { name: "El Porvenir", state: "Chiriquí" },
      { name: "El Prado", state: "Veraguas" },
      { name: "Toabré", state: "Coclé" },
      { name: "El Muñoz", state: "Los Santos" },
      { name: "San Pablo Nuevo", state: "Chiriquí" },
      { name: "Cirí de Los Sotos", state: "Panamá Oeste" },
      { name: "La Arenosa", state: "Panamá Oeste" },
      { name: "Toza", state: "Coclé" },
      { name: "El Guásimo", state: "Los Santos" },
      { name: "Norteño", state: "Bocas del Toro" },
      { name: "Punta Róbalo", state: "Bocas del Toro" },
      { name: "Cermeño", state: "Panamá Oeste" },
      { name: "Piedra Roja", state: "Ngäbe-Buglé" },
      { name: "Las Cruces", state: "Los Santos" },
      { name: "Sorá", state: "Panamá Oeste" },
      { name: "Boró", state: "Veraguas" },
      { name: "Las Palmas", state: "Veraguas" },
      { name: "San Bartolo", state: "Veraguas" },
      { name: "Nueva Arenosa", state: "Panamá Oeste" },
      { name: "Rincón", state: "Chiriquí" },
      { name: "Bisvalles", state: "Veraguas" },
      { name: "Bahía Honda", state: "Herrera" },
      { name: "Las Minas", state: "Herrera" },
      { name: "El Copé", state: "Coclé" },
      { name: "Mendoza", state: "Panamá Oeste" },
      { name: "Lolá", state: "Veraguas" },
      { name: "Perales", state: "Los Santos" },
      { name: "Chiriquí", state: "Chiriquí" },
      { name: "Llano Grande", state: "Veraguas" },
      { name: "Río de Jesús", state: "Veraguas" },
      { name: "Plan de Chorcha", state: "Ngäbe-Buglé" },
      { name: "Los Cerros de Paja", state: "Herrera" },
      { name: "Los Corotúes", state: "Veraguas" },
      { name: "La Laguna", state: "Panamá Oeste" },
      { name: "El Calabacito", state: "Herrera" },
      { name: "Miramar", state: "Colón" },
      { name: "Bajo Solís", state: "Chiriquí" },
      { name: "Chumical", state: "Herrera" },
      { name: "Las Margaritas", state: "Panamá" },
      { name: "Santa Rosa Número Uno", state: "Panamá Oeste" },
      { name: "Bahía Honda", state: "Los Santos" },
      { name: "Potrero de Caña", state: "Ngäbe-Buglé" },
      { name: "Corozal", state: "Veraguas" },
      { name: "Salud", state: "Colón" },
      { name: "Boca de Río Indio", state: "Colón" },
      { name: "El Cedro", state: "Herrera" },
      { name: "Cauchero", state: "Bocas del Toro" },
      { name: "Nuestro Amo", state: "Coclé" },
      { name: "La Encantada", state: "Colón" },
      { name: "Hato Chamí", state: "Ngäbe-Buglé" },
      { name: "Peñas Chatas", state: "Herrera" },
      { name: "El Pedregoso", state: "Los Santos" },
      { name: "El Bale", state: "Ngäbe-Buglé" },
      { name: "Sardinilla", state: "Colón" },
      { name: "Bijagual", state: "Chiriquí" },
      { name: "Guzmán", state: "Coclé" },
      { name: "El Copé", state: "Coclé" },
      { name: "Limones", state: "Chiriquí" },
      { name: "La Laguna", state: "Panamá Oeste" },
      { name: "Olá", state: "Coclé" },
      { name: "Las Minas", state: "Coclé" },
      { name: "Breñón", state: "Chiriquí" },
      { name: "Juay", state: "Chiriquí" },
      { name: "El Marañón", state: "Veraguas" },
      { name: "Quebrada del Rosario Arriba", state: "Herrera" },
      { name: "Cedro Arriba", state: "Los Santos" },
      { name: "Gobea", state: "Colón" },
      { name: "Llano Grande", state: "Coclé" },
      { name: "El Bebedero", state: "Los Santos" },
      { name: "La Mesa", state: "Veraguas" },
      { name: "Palo Grande", state: "Chiriquí" },
      { name: "La Trinidad", state: "Herrera" },
      { name: "Las Marias", state: "Coclé" },
      { name: "Llano Grande", state: "Herrera" },
      { name: "La Esmeralda", state: "Panamá" },
      { name: "El Espino Amarillo", state: "Los Santos" },
      { name: "Bella Vista", state: "Chiriquí" },
      { name: "Las Trancas", state: "Los Santos" },
      { name: "Cerro Plata", state: "Ngäbe-Buglé" },
      { name: "Güibale", state: "Ngäbe-Buglé" },
      { name: "Utirá", state: "Veraguas" },
      { name: "Paritilla", state: "Los Santos" },
      { name: "San Lorenzo", state: "Chiriquí" },
      { name: "Pueblo Nuevo", state: "Panamá Oeste" },
      { name: "Las Guías Abajo", state: "Veraguas" },
      { name: "El Picador", state: "Veraguas" },
      { name: "El Peñón", state: "Veraguas" },
      { name: "San Marcelo", state: "Veraguas" },
      { name: "El Toro", state: "Herrera" },
      { name: "Las Huacas del Quije", state: "Coclé" },
      { name: "San José", state: "Veraguas" },
      { name: "Cerro Plata", state: "Veraguas" },
      { name: "Arosemena", state: "Panamá Oeste" },
      { name: "Guayabito", state: "Panamá Oeste" },
      { name: "Leones Arriba", state: "Veraguas" },
      { name: "Rodeo Viejo", state: "Veraguas" },
      { name: "Monjarás", state: "Veraguas" },
      { name: "Río Grande", state: "Veraguas" },
      { name: "Santa Catalina", state: "Ngäbe-Buglé" },
      { name: "La Carrillo", state: "Veraguas" },
      { name: "París", state: "Herrera" },
      { name: "Cerro Largo", state: "Herrera" },
      { name: "San Juan", state: "Chiriquí" },
      { name: "Los Higos", state: "Veraguas" },
      { name: "Achiote", state: "Colón" },
      { name: "Gatú", state: "Veraguas" },
      { name: "La Mesa", state: "Los Santos" },
      { name: "Viento Frío", state: "Colón" },
      { name: "Paredón Arriba", state: "Ngäbe-Buglé" },
      { name: "El Potrero", state: "Veraguas" },
      { name: "Piedras Gordas", state: "Veraguas" },
      { name: "Horconcitos", state: "Chiriquí" },
      { name: "Barnizal", state: "Veraguas" },
      { name: "Pitaloza Arriba", state: "Herrera" },
      { name: "Viguí", state: "Veraguas" },
      { name: "Cordillera", state: "Chiriquí" },
      { name: "El Pantano", state: "Veraguas" },
      { name: "Río Grande", state: "Ngäbe-Buglé" },
      { name: "Quebrada Tula", state: "Ngäbe-Buglé" },
      { name: "Puerto Vidal", state: "Veraguas" },
      { name: "San José", state: "Veraguas" },
      { name: "Los Valles", state: "Veraguas" },
      { name: "Las Sabanas", state: "Coclé" },
      { name: "El Cocla", state: "Veraguas" },
      { name: "La Yeguada", state: "Veraguas" },
      { name: "Lajas de Tolé", state: "Chiriquí" },
      { name: "Narganá", state: "Guna Yala" },
      { name: "Leones Arriba", state: "Herrera" },
      { name: "Chepo", state: "Herrera" },
      { name: "Agua Fría Número Uno", state: "Darién" },
      { name: "Lajas Adentro", state: "Chiriquí" },
      { name: "Las Huacas", state: "Veraguas" },
      { name: "Cascabel", state: "Ngäbe-Buglé" },
      { name: "La Boca del Guásimo", state: "Colón" },
      { name: "El Líbano", state: "Panamá Oeste" },
      { name: "Barranco Colorado", state: "Coclé" },
      { name: "El Cacao", state: "Los Santos" },
      { name: "El Pájaro", state: "Veraguas" },
      { name: "Guarumal", state: "Veraguas" },
      { name: "La Soledad", state: "Veraguas" },
      { name: "Tortí", state: "Panamá" },
      { name: "Lajamina", state: "Los Santos" },
      { name: "El María", state: "Veraguas" },
      { name: "Valle Rico", state: "Los Santos" },
      { name: "San José", state: "Los Santos" },
      { name: "Boca del Monte", state: "Chiriquí" },
      { name: "Pinogana", state: "Darién" },
      { name: "Los Ángeles", state: "Chiriquí" },
      { name: "Los Castillos", state: "Veraguas" },
      { name: "El Macano", state: "Los Santos" },
      { name: "Quebrada de Piedra", state: "Chiriquí" },
      { name: "Valle de Las Minas", state: "Chiriquí" },
      { name: "Paraíso", state: "Los Santos" },
      { name: "Boca de Río Chiriquí", state: "Ngäbe-Buglé" },
      { name: "Palmira", state: "Los Santos" },
      { name: "Coronte", state: "Ngäbe-Buglé" },
      { name: "El Alto", state: "Veraguas" },
      { name: "Limón de Tijeras", state: "Herrera" },
      { name: "Ponuga", state: "Veraguas" },
      { name: "Los Asientos", state: "Los Santos" },
      { name: "San Miguel", state: "Panamá" },
      { name: "Calidonia", state: "Veraguas" },
      { name: "Palenque", state: "Colón" },
      { name: "Caldera", state: "Chiriquí" },
      { name: "Paja de Sombrero", state: "Chiriquí" },
      { name: "Bajo Corral", state: "Los Santos" },
      { name: "La Tronosa", state: "Los Santos" },
      { name: "Cañita", state: "Panamá" },
      { name: "Calovébora", state: "Veraguas" },
      { name: "El Llano", state: "Panamá" },
      { name: "La Miel", state: "Los Santos" },
      { name: "Río Luís", state: "Veraguas" },
      { name: "Vallerriquito", state: "Los Santos" },
      { name: "La Raya de Calobre", state: "Veraguas" },
      { name: "La Laguna", state: "Veraguas" },
      { name: "Cucunatí", state: "Darién" },
      { name: "Boquerón", state: "Veraguas" },
      { name: "Mariabé", state: "Los Santos" },
      { name: "Las Palmas", state: "Los Santos" },
      { name: "La Garceana", state: "Veraguas" },
      { name: "Platanilla", state: "Darién" },
      { name: "Cañas", state: "Los Santos" },
      { name: "El Cañafístulo", state: "Los Santos" },
      { name: "Altos de Güera", state: "Los Santos" },
      { name: "Bajos de Güera", state: "Los Santos" },
      { name: "Flores", state: "Los Santos" },
      { name: "Río Hondo", state: "Los Santos" },
      { name: "Santa Cruz", state: "Chiriquí" },
      { name: "Bayano", state: "Los Santos" },
      { name: "Tebario", state: "Veraguas" },
      { name: "Río Sábalo", state: "Emberá" },
      { name: "Mogollón", state: "Los Santos" },
      { name: "El Cortezo", state: "Los Santos" },
      { name: "Pásiga", state: "Panamá" },
      { name: "Puerto Obaldía", state: "Guna Yala" },
      { name: "Zapotillo", state: "Veraguas" },
      { name: "Pedro González", state: "Panamá" },
      { name: "Valle de Riscó", state: "Bocas del Toro" },
      { name: "Boca de Sábalo", state: "Emberá" },
      { name: "Quebro", state: "Veraguas" },
      { name: "Boca Chica", state: "Chiriquí" },
      { name: "Arenas", state: "Veraguas" },
      { name: "Barriales", state: "Darién" },
      { name: "Unión Santeña", state: "Panamá" },
      { name: "Loma Yuca", state: "Ngäbe-Buglé" },
      { name: "Cambutal", state: "Los Santos" },
      { name: "Oria Arriba", state: "Los Santos" },
      { name: "Lajas Blancas", state: "Emberá" },
      { name: "La Guinea", state: "Panamá" },
      { name: "Mortí", state: "Darién" },
      { name: "Corozal", state: "Emberá" },
      { name: "Nuario", state: "Los Santos" },
      { name: "La Ensenada", state: "Panamá" },
      { name: "Jingurudó", state: "Emberá" },
      { name: "Púcuro", state: "Darién" },
      { name: "Paya", state: "Darién" },
      { name: "Gobernadora", state: "Veraguas" },
      { name: "Pueblo Nuevo", state: "Darién" },
    ],
  },
  SN: {
    states: [
      { name: "Dakar", code: "SN-DK", minZip: 0, maxZip: 999999 },
      { name: "Diourbel", code: "SN-DB", minZip: 0, maxZip: 999999 },
      { name: "Fatick", code: "SN-FK", minZip: 0, maxZip: 999999 },
      { name: "Kaffrine", code: "SN-KA", minZip: 0, maxZip: 999999 },
      { name: "Kaolack", code: "SN-KL", minZip: 0, maxZip: 999999 },
      { name: "Kédougou", code: "SN-KE", minZip: 0, maxZip: 999999 },
      { name: "Kolda", code: "SN-KD", minZip: 0, maxZip: 999999 },
      { name: "Louga", code: "SN-LG", minZip: 0, maxZip: 999999 },
      { name: "Matam", code: "SN-MT", minZip: 0, maxZip: 999999 },
      { name: "Saint-Louis", code: "SN-SL", minZip: 0, maxZip: 999999 },
      { name: "Sédhiou", code: "SN-SE", minZip: 0, maxZip: 999999 },
      { name: "Tambacounda", code: "SN-TC", minZip: 0, maxZip: 999999 },
      { name: "Thiès", code: "SN-TH", minZip: 0, maxZip: 999999 },
      { name: "Ziguinchor", code: "SN-ZG", minZip: 0, maxZip: 999999 },
    ],
    cities: [],
  },
  US: {
    states: [
      { name: "Alabama", code: "AL" },
      { name: "Alaska", code: "AK" },
      { name: "Arizona", code: "AZ" },
      { name: "Arkansas", code: "AR" },
      { name: "California", code: "CA" },
      { name: "Colorado", code: "CO" },
      { name: "Connecticut", code: "CT" },
      { name: "Delaware", code: "DE" },
      { name: "Florida", code: "FL" },
      { name: "Georgia", code: "GA" },
      { name: "Hawaii", code: "HI" },
      { name: "Idaho", code: "ID" },
      { name: "Illinois", code: "IL" },
      { name: "Indiana", code: "IN" },
      { name: "Iowa", code: "IA" },
      { name: "Kansas", code: "KS" },
      { name: "Kentucky", code: "KY" },
      { name: "Louisiana", code: "LA" },
      { name: "Maine", code: "ME" },
      { name: "Maryland", code: "MD" },
      { name: "Massachusetts", code: "MA" },
      { name: "Michigan", code: "MI" },
      { name: "Minnesota", code: "MN" },
      { name: "Mississippi", code: "MS" },
      { name: "Missouri", code: "MO" },
      { name: "Montana", code: "MT" },
      { name: "Nebraska", code: "NE" },
      { name: "Nevada", code: "NV" },
      { name: "New Hampshire", code: "NH" },
      { name: "New Jersey", code: "NJ" },
      { name: "New Mexico", code: "NM" },
      { name: "New York", code: "NY" },
      { name: "North Carolina", code: "NC" },
      { name: "North Dakota", code: "ND" },
      { name: "Ohio", code: "OH" },
      { name: "Oklahoma", code: "OK" },
      { name: "Puerto Rico", code: "PR" },
      { name: "Oregon", code: "OR" },
      { name: "Pennsylvania", code: "PA" },
      { name: "Rhode Island", code: "RI" },
      { name: "South Carolina", code: "SC" },
      { name: "South Dakota", code: "SD" },
      { name: "Tennessee", code: "TN" },
      { name: "Texas", code: "TX" },
      { name: "Utah", code: "UT" },
      { name: "Vermont", code: "VT" },
      { name: "Virginia", code: "VA" },
      { name: "Washington", code: "WA" },
      { name: "Washington DC", code: "DC" },
      { name: "West Virginia", code: "WV" },
      { name: "Wisconsin", code: "WI" },
      { name: "Wyoming", code: "WY" },
    ],
    cities: [],
  },
  ZA: {
    states: [
      { name: "Eastern Cape", code: "ZA-EC", minZip: 0, maxZip: 999999 },
      { name: "Free State", code: "ZA-FS", minZip: 0, maxZip: 999999 },
      { name: "Gauteng", code: "ZA-GT", minZip: 0, maxZip: 999999 },
      { name: "KwaZulu Natal", code: "ZA-NL", minZip: 0, maxZip: 999999 },
      { name: "Limpopo", code: "ZA-NP", minZip: 0, maxZip: 999999 },
      { name: "Mpumalanga", code: "ZA-MP", minZip: 0, maxZip: 999999 },
      { name: "Northern Cape", code: "ZA-NC", minZip: 0, maxZip: 999999 },
      { name: "North West", code: "ZA-NW", minZip: 0, maxZip: 999999 },
      { name: "Western Cape", code: "ZA-WC", minZip: 0, maxZip: 999999 },
    ],
    cities: [
      { name: "Aberdeen", state: "Eastern Cape" },
      { name: "Addo", state: "Eastern Cape" },
      { name: "Adelaide (iKhobonqaba)", state: "Eastern Cape" },
      { name: "Alexandria", state: "Eastern Cape" },
      { name: "Alice (iDikeni)", state: "Eastern Cape" },
      { name: "Aliwal North (Maletswai)", state: "Eastern Cape" },
      { name: "Barkly East", state: "Eastern Cape" },
      { name: "Bathurst", state: "Eastern Cape" },
      { name: "Bedford", state: "Eastern Cape" },
      { name: "Berlin", state: "Eastern Cape" },
      { name: "Bethulie", state: "Eastern Cape" },
      { name: "Bisho (Bhisho)", state: "Eastern Cape" },
      { name: "Bizana", state: "Eastern Cape" },
      { name: "Braunschweig", state: "Eastern Cape" },
      { name: "Burgersdorp", state: "Eastern Cape" },
      { name: "Butterworth (Gcuwa)", state: "Eastern Cape" },
      { name: "Cala", state: "Eastern Cape" },
      { name: "Cathcart", state: "Eastern Cape" },
      { name: "Cedarville", state: "Eastern Cape" },
      { name: "Cintsa (Chintsa)", state: "Eastern Cape" },
      { name: "Coffee Bay", state: "Eastern Cape" },
      { name: "Cofimvaba", state: "Eastern Cape" },
      { name: "Cookhouse", state: "Eastern Cape" },
      { name: "Cradock", state: "Eastern Cape" },
      { name: "Despatch", state: "Eastern Cape" },
      { name: "Dohne", state: "Eastern Cape" },
      { name: "Dordrecht", state: "Eastern Cape" },
      { name: "East London (eMonti)", state: "Eastern Cape" },
      { name: "Elliot (Khowa)", state: "Eastern Cape" },
      { name: "Elliotdale", state: "Eastern Cape" },
      { name: "Engcobo (Ngcobo)", state: "Eastern Cape" },
      { name: "Enon", state: "Eastern Cape" },
      { name: "Flagstaff", state: "Eastern Cape" },
      { name: "Fort Beaufort (eBhofolo)", state: "Eastern Cape" },
      { name: "Gonubie", state: "Eastern Cape" },
      { name: "Graaff Reinet", state: "Eastern Cape" },
      { name: "Grahamstown (Makhanda)", state: "Eastern Cape" },
      { name: "Haga-Haga", state: "Eastern Cape" },
      { name: "Hamburg", state: "Eastern Cape" },
      { name: "Hankey", state: "Eastern Cape" },
      { name: "Hertzog (Mhlangeni)", state: "Eastern Cape" },
      { name: "Hofmeyr", state: "Eastern Cape" },
      { name: "Hogsback", state: "Eastern Cape" },
      { name: "Humansdorp", state: "Eastern Cape" },
      { name: "Idutywa (Dutywa)", state: "Eastern Cape" },
      { name: "Indwe", state: "Eastern Cape" },
      { name: "Jamestown", state: "Eastern Cape" },
      { name: "Jeffreys Bay", state: "Eastern Cape" },
      { name: "Joubertina", state: "Eastern Cape" },
      { name: "Kareedouw", state: "Eastern Cape" },
      { name: "Katberg", state: "Eastern Cape" },
      { name: "Kei Mouth", state: "Eastern Cape" },
      { name: "Keiskammahoek", state: "Eastern Cape" },
      { name: "Kentani (Centane)", state: "Eastern Cape" },
      { name: "Kenton-on-Sea", state: "Eastern Cape" },
      { name: "Kidds Beach", state: "Eastern Cape" },
      { name: "King William's Town (Qonce)", state: "Eastern Cape" },
      { name: "Kirkwood", state: "Eastern Cape" },
      { name: "Komga", state: "Eastern Cape" },
      { name: "Krakeelrivier", state: "Eastern Cape" },
      { name: "Lady Frere (Cacadu)", state: "Eastern Cape" },
      { name: "Lady Frere (Cacadu)", state: "Eastern Cape" },
      { name: "Lady Grey", state: "Eastern Cape" },
      { name: "Libode", state: "Eastern Cape" },
      { name: "Lusikisiki", state: "Eastern Cape" },
      { name: "Maclear (Nqanqarhu)", state: "Eastern Cape" },
      { name: "Matatiele", state: "Eastern Cape" },
      { name: "Mdantsane", state: "Eastern Cape" },
      { name: "Middelburg", state: "Eastern Cape" },
      { name: "Molteno", state: "Eastern Cape" },
      { name: "Morgan's Bay", state: "Eastern Cape" },
      { name: "Mount Ayliff (eMaxesibeni)", state: "Eastern Cape" },
      { name: "Mount Fletcher (Tlokoeng)", state: "Eastern Cape" },
      { name: "Mount Frere", state: "Eastern Cape" },
      { name: "Mount Frere (KwaBhaca)", state: "Eastern Cape" },
      { name: "Ngqeleni", state: "Eastern Cape" },
      { name: "Nieu-Bethesda", state: "Eastern Cape" },
      { name: "Nqamakwe", state: "Eastern Cape" },
      { name: "Oyster Bay", state: "Eastern Cape" },
      { name: "Patensie", state: "Eastern Cape" },
      { name: "Paterson", state: "Eastern Cape" },
      { name: "Peddie", state: "Eastern Cape" },
      { name: "Port Alfred", state: "Eastern Cape" },
      { name: "Port Elizabeth (Gqeberha)", state: "Eastern Cape" },
      { name: "Port St Johns", state: "Eastern Cape" },
      { name: "Qolora Mouth", state: "Eastern Cape" },
      { name: "Queenstown (Komani)", state: "Eastern Cape" },
      { name: "Qumbu", state: "Eastern Cape" },
      { name: "Salem", state: "Eastern Cape" },
      { name: "Seymour", state: "Eastern Cape" },
      { name: "Somerset East", state: "Eastern Cape" },
      { name: "Sophangisa's land", state: "Eastern Cape" },
      { name: "St Francis Bay", state: "Eastern Cape" },
      { name: "Sterkspruit", state: "Eastern Cape" },
      { name: "Sterkstroom", state: "Eastern Cape" },
      { name: "Steynsburg, Eastern Cape", state: "Eastern Cape" },
      { name: "Steytlerville", state: "Eastern Cape" },
      { name: "Stutterheim", state: "Eastern Cape" },
      { name: "Tabankulu (Ntabankulu)", state: "Eastern Cape" },
      { name: "Tarkastad", state: "Eastern Cape" },
      { name: "The Western Region", state: "Eastern Cape" },
      { name: "The Wild Coast", state: "Eastern Cape" },
      { name: "Tsolo", state: "Eastern Cape" },
      { name: "Tsomo", state: "Eastern Cape" },
      { name: "Uitenhage (Kariega)", state: "Eastern Cape" },
      { name: "Umtata (Mthatha)", state: "Eastern Cape" },
      { name: "Venterstad", state: "Eastern Cape" },
      { name: "Whittlesea", state: "Eastern Cape" },
      { name: "Willowmore", state: "Eastern Cape" },
      { name: "Willowvale (Gatyane)", state: "Eastern Cape" },
      { name: "Zwelitsha", state: "Eastern Cape" },
      { name: "Allanridge", state: "Free State" },
      { name: "Arlington", state: "Free State" },
      { name: "Bethlehem", state: "Free State" },
      { name: "Bethulie", state: "Free State" },
      { name: "Blesberg (Thaba 'Nchu)", state: "Free State" },
      { name: "Bloemfontein", state: "Free State" },
      { name: "Boshof", state: "Free State" },
      { name: "Bothaville", state: "Free State" },
      { name: "Botshabelo", state: "Free State" },
      { name: "Brandfort", state: "Free State" },
      { name: "Bultfontein", state: "Free State" },
      { name: "Clarens", state: "Free State" },
      { name: "Clocolan", state: "Free State" },
      { name: "Cornelia", state: "Free State" },
      { name: "Dealesville", state: "Free State" },
      { name: "Deneysville", state: "Free State" },
      { name: "Dewetsdorp", state: "Free State" },
      { name: "Edenburg", state: "Free State" },
      { name: "Edenville", state: "Free State" },
      { name: "Excelsior", state: "Free State" },
      { name: "Fauresmith", state: "Free State" },
      { name: "Ficksburg", state: "Free State" },
      { name: "Fouriesburg", state: "Free State" },
      { name: "Frankfort", state: "Free State" },
      { name: "Harrismith", state: "Free State" },
      { name: "Heilbron", state: "Free State" },
      { name: "Hennenman", state: "Free State" },
      { name: "Hertzogville", state: "Free State" },
      { name: "Hobhouse", state: "Free State" },
      { name: "Hoopstad", state: "Free State" },
      { name: "Jacobsdal", state: "Free State" },
      { name: "Jagersfontein", state: "Free State" },
      { name: "Kestell", state: "Free State" },
      { name: "Koffiefontein", state: "Free State" },
      { name: "Koppies", state: "Free State" },
      { name: "Kroonstad", state: "Free State" },
      { name: "Ladybrand", state: "Free State" },
      { name: "Lejweleputswa (formerly GoldFields)", state: "Free State" },
      { name: "Lindley", state: "Free State" },
      { name: "Luckhoff", state: "Free State" },
      { name: "Marquard", state: "Free State" },
      { name: "Memel", state: "Free State" },
      { name: "Mvela", state: "Free State" },
      { name: "Northern Free State", state: "Free State" },
      { name: "Odendaalsrus", state: "Free State" },
      { name: "Oranjeville", state: "Free State" },
      { name: "Parys", state: "Free State" },
      { name: "Paul Roux", state: "Free State" },
      { name: "Petrus Steyn", state: "Free State" },
      { name: "Petrusburg", state: "Free State" },
      { name: "Philippolis", state: "Free State" },
      { name: "Reddersburg", state: "Free State" },
      { name: "Reitz", state: "Free State" },
      { name: "Rosendal", state: "Free State" },
      { name: "Rouxville", state: "Free State" },
      { name: "Sasolburg", state: "Free State" },
      { name: "Senekal", state: "Free State" },
      { name: "Smithfield", state: "Free State" },
      { name: "Springfontein", state: "Free State" },
      { name: "Steynsrus", state: "Free State" },
      { name: "Swinburne", state: "Free State" },
      { name: "Theunissen", state: "Free State" },
      { name: "Transgariep", state: "Free State" },
      { name: "Trompsburg", state: "Free State" },
      { name: "Tweeling", state: "Free State" },
      { name: "Tweespruit", state: "Free State" },
      { name: "Van Reenen", state: "Free State" },
      { name: "Van Stadensrus", state: "Free State" },
      { name: "Ventersburg", state: "Free State" },
      { name: "Verkeerdevlei", state: "Free State" },
      { name: "Viljoenskroon", state: "Free State" },
      { name: "Villiers", state: "Free State" },
      { name: "Virginia", state: "Free State" },
      { name: "Vrede", state: "Free State" },
      { name: "Vredefort", state: "Free State" },
      { name: "Warden", state: "Free State" },
      { name: "Welkom", state: "Free State" },
      { name: "Wepener", state: "Free State" },
      { name: "Wesselsbron", state: "Free State" },
      { name: "Winburg", state: "Free State" },
      { name: "Winburg", state: "Free State" },
      { name: "Witsieshoek (Phuthaditjhaba)", state: "Free State" },
      { name: "Zastron", state: "Free State" },
      { name: "Alberton", state: "Gauteng" },
      { name: "Alexandra", state: "Gauteng" },
      { name: "Atteridgeville", state: "Gauteng" },
      { name: "Bekkersdal", state: "Gauteng" },
      { name: "Benoni", state: "Gauteng" },
      { name: "Boipatong", state: "Gauteng" },
      { name: "Boksburg", state: "Gauteng" },
      { name: "Bophelong", state: "Gauteng" },
      { name: "Brakpan", state: "Gauteng" },
      { name: "Bronberg", state: "Gauteng" },
      { name: "Bronkhorstspruit", state: "Gauteng" },
      { name: "Carletonville", state: "Gauteng" },
      { name: "Centurion", state: "Gauteng" },
      { name: "Cullinan", state: "Gauteng" },
      { name: "Daveyton", state: "Gauteng" },
      { name: "Devon", state: "Gauteng" },
      { name: "Duduza", state: "Gauteng" },
      { name: "Edenvale", state: "Gauteng" },
      { name: "Ekangala", state: "Gauteng" },
      { name: "Evaton", state: "Gauteng" },
      { name: "Germiston", state: "Gauteng" },
      { name: "Germiston", state: "Gauteng" },
      { name: "Hammanskraal", state: "Gauteng" },
      { name: "Heidelberg", state: "Gauteng" },
      { name: "Impumelelo", state: "Gauteng" },
      { name: "Irene", state: "Gauteng" },
      { name: "Isando", state: "Gauteng" },
      { name: "Johannesburg", state: "Gauteng" },
      { name: "Kagiso", state: "Gauteng" },
      { name: "Katlehong", state: "Gauteng" },
      { name: "Kempton Park", state: "Gauteng" },
      { name: "Khutsong", state: "Gauteng" },
      { name: "Kromdraai", state: "Gauteng" },
      { name: "Krugersdorp", state: "Gauteng" },
      { name: "KwaThema", state: "Gauteng" },
      { name: "Lenasia", state: "Gauteng" },
      { name: "Magaliesburg", state: "Gauteng" },
      { name: "Mamelodi", state: "Gauteng" },
      { name: "Meyerton", state: "Gauteng" },
      { name: "Midrand", state: "Gauteng" },
      { name: "Mohlakeng", state: "Gauteng" },
      { name: "Muldersdrift", state: "Gauteng" },
      { name: "Nigel", state: "Gauteng" },
      { name: "Pretoria", state: "Gauteng" },
      { name: "Randburg", state: "Gauteng" },
      { name: "Randfontein", state: "Gauteng" },
      { name: "Ratanda", state: "Gauteng" },
      { name: "Refilwe", state: "Gauteng" },
      { name: "Reiger Park", state: "Gauteng" },
      { name: "Roodepoort", state: "Gauteng" },
      { name: "Sandton", state: "Gauteng" },
      { name: "Sebokeng", state: "Gauteng" },
      { name: "Sharpeville", state: "Gauteng" },
      { name: "Soshanguve", state: "Gauteng" },
      { name: "Soweto", state: "Gauteng" },
      { name: "Springs", state: "Gauteng" },
      { name: "Tembisa", state: "Gauteng" },
      { name: "Thokoza", state: "Gauteng" },
      { name: "Tsakane", state: "Gauteng" },
      { name: "Vanderbijlpark", state: "Gauteng" },
      { name: "Vereeniging", state: "Gauteng" },
      { name: "Vosloorus", state: "Gauteng" },
      { name: "Wattville", state: "Gauteng" },
      { name: "Westonaria", state: "Gauteng" },
      { name: "Zithobeni", state: "Gauteng" },
      { name: "Adams Mission", state: "KwaZulu Natal" },
      { name: "Amanzimtoti", state: "KwaZulu Natal" },
      { name: "Anerley", state: "KwaZulu Natal" },
      { name: "Assagay", state: "KwaZulu Natal" },
      { name: "Babanango", state: "KwaZulu Natal" },
      { name: "Balgowan", state: "KwaZulu Natal" },
      { name: "Ballito", state: "KwaZulu Natal" },
      { name: "Bazley Beach", state: "KwaZulu Natal" },
      { name: "Bergville", state: "KwaZulu Natal" },
      { name: "Boston", state: "KwaZulu Natal" },
      { name: "Botha's Hill", state: "KwaZulu Natal" },
      { name: "Bulwer", state: "KwaZulu Natal" },
      { name: "Cato Ridge", state: "KwaZulu Natal" },
      { name: "Charlestown", state: "KwaZulu Natal" },
      { name: "Chatsworth", state: "KwaZulu Natal" },
      { name: "Clermont", state: "KwaZulu Natal" },
      { name: "Colenso", state: "KwaZulu Natal" },
      { name: "Dalton", state: "KwaZulu Natal" },
      { name: "Dannhauser", state: "KwaZulu Natal" },
      { name: "Dududu", state: "KwaZulu Natal" },
      { name: "Dundee", state: "KwaZulu Natal" },
      { name: "Durban", state: "KwaZulu Natal" },
      { name: "ekuPhakameni", state: "KwaZulu Natal" },
      { name: "Elandslaagte", state: "KwaZulu Natal" },
      { name: "Emadlangeni", state: "KwaZulu Natal" },
      { name: "Empangeni", state: "KwaZulu Natal" },
      { name: "Eshowe", state: "KwaZulu Natal" },
      { name: "Estcourt", state: "KwaZulu Natal" },
      { name: "eThekwini", state: "KwaZulu Natal" },
      { name: "Franklin", state: "KwaZulu Natal" },
      { name: "Gillitts", state: "KwaZulu Natal" },
      { name: "Glencoe", state: "KwaZulu Natal" },
      { name: "Greytown", state: "KwaZulu Natal" },
      { name: "Harding", state: "KwaZulu Natal" },
      { name: "Harry Gwala", state: "KwaZulu Natal" },
      { name: "Hattingspruit", state: "KwaZulu Natal" },
      { name: "Hibberdene", state: "KwaZulu Natal" },
      { name: "Hillcrest", state: "KwaZulu Natal" },
      { name: "Hilton", state: "KwaZulu Natal" },
      { name: "Himeville", state: "KwaZulu Natal" },
      { name: "Hluhluwe", state: "KwaZulu Natal" },
      { name: "Howick", state: "KwaZulu Natal" },
      { name: "Ifafa Beach", state: "KwaZulu Natal" },
      { name: "iLembe", state: "KwaZulu Natal" },
      { name: "Inanda", state: "KwaZulu Natal" },
      { name: "Inchanga", state: "KwaZulu Natal" },
      { name: "Ingwavuma", state: "KwaZulu Natal" },
      { name: "Isipingo", state: "KwaZulu Natal" },
      { name: "Izingolweni (eZinqoleni)", state: "KwaZulu Natal" },
      { name: "Jozini", state: "KwaZulu Natal" },
      { name: "Kelso", state: "KwaZulu Natal" },
      { name: "King Cetshwayo", state: "KwaZulu Natal" },
      { name: "Kingsburgh", state: "KwaZulu Natal" },
      { name: "Kingsley", state: "KwaZulu Natal" },
      { name: "Kloof", state: "KwaZulu Natal" },
      { name: "Kokstad", state: "KwaZulu Natal" },
      { name: "Kosi Bay town (Manguzi)", state: "KwaZulu Natal" },
      { name: "Kranskop", state: "KwaZulu Natal" },
      { name: "KwaMakhutha", state: "KwaZulu Natal" },
      { name: "KwaMashu", state: "KwaZulu Natal" },
      { name: "La Mercy", state: "KwaZulu Natal" },
      { name: "Ladysmith", state: "KwaZulu Natal" },
      { name: "Louwsburg", state: "KwaZulu Natal" },
      { name: "Madadeni", state: "KwaZulu Natal" },
      { name: "Mahlabatini", state: "KwaZulu Natal" },
      { name: "Mandeni", state: "KwaZulu Natal" },
      { name: "Maphumulo", state: "KwaZulu Natal" },
      { name: "Margate", state: "KwaZulu Natal" },
      { name: "Mbazwana", state: "KwaZulu Natal" },
      { name: "Melmoth", state: "KwaZulu Natal" },
      { name: "Melville", state: "KwaZulu Natal" },
      { name: "Merrivale", state: "KwaZulu Natal" },
      { name: "Mkuze", state: "KwaZulu Natal" },
      { name: "Mooi River", state: "KwaZulu Natal" },
      { name: "Mountain View (Osizweni)", state: "KwaZulu Natal" },
      { name: "Mpumalanga", state: "KwaZulu Natal" },
      { name: "Mtubatuba", state: "KwaZulu Natal" },
      { name: "Mtunzini", state: "KwaZulu Natal" },
      { name: "Munster", state: "KwaZulu Natal" },
      { name: "New Germany", state: "KwaZulu Natal" },
      { name: "New Hanover", state: "KwaZulu Natal" },
      { name: "Newcastle", state: "KwaZulu Natal" },
      { name: "Ngagane", state: "KwaZulu Natal" },
      { name: "Nkandla", state: "KwaZulu Natal" },
      { name: "Nongoma", state: "KwaZulu Natal" },
      { name: "Nquthu", state: "KwaZulu Natal" },
      { name: "Ntuzuma", state: "KwaZulu Natal" },
      { name: "Palm Beach", state: "KwaZulu Natal" },
      { name: "Park Rynie", state: "KwaZulu Natal" },
      { name: "Paulpietersburg", state: "KwaZulu Natal" },
      { name: "Pennington", state: "KwaZulu Natal" },
      { name: "Phoenix", state: "KwaZulu Natal" },
      { name: "Pietermaritzburg", state: "KwaZulu Natal" },
      { name: "Pinetown", state: "KwaZulu Natal" },
      { name: "Pomeroy", state: "KwaZulu Natal" },
      { name: "Pongola", state: "KwaZulu Natal" },
      { name: "Port Edward", state: "KwaZulu Natal" },
      { name: "Port Shepstone", state: "KwaZulu Natal" },
      { name: "Prospecton", state: "KwaZulu Natal" },
      { name: "Queensburgh", state: "KwaZulu Natal" },
      { name: "Ramsgate", state: "KwaZulu Natal" },
      { name: "Richards Bay", state: "KwaZulu Natal" },
      { name: "Richmond", state: "KwaZulu Natal" },
      { name: "Salt Rock", state: "KwaZulu Natal" },
      { name: "Scottburgh", state: "KwaZulu Natal" },
      { name: "Sezela", state: "KwaZulu Natal" },
      { name: "Shallcross", state: "KwaZulu Natal" },
      { name: "Shelly Beach", state: "KwaZulu Natal" },
      { name: "Southbroom", state: "KwaZulu Natal" },
      { name: "Stanger (KwaDukuza)", state: "KwaZulu Natal" },
      { name: "Stuartstown (Ixopo)", state: "KwaZulu Natal" },
      { name: "Tongaat (oThongathi)", state: "KwaZulu Natal" },
      { name: "Ubombo", state: "KwaZulu Natal" },
      { name: "Ugu", state: "KwaZulu Natal" },
      { name: "Ulundi", state: "KwaZulu Natal" },
      { name: "Umbumbulu", state: "KwaZulu Natal" },
      { name: "Umdloti (eMdloti)", state: "KwaZulu Natal" },
      { name: "Umgababa", state: "KwaZulu Natal" },
      { name: "uMgungundlovu", state: "KwaZulu Natal" },
      { name: "Umhlanga (uMhlanga)", state: "KwaZulu Natal" },
      { name: "UMkhanyakude", state: "KwaZulu Natal" },
      { name: "Umkomaas (eMkhomazi)", state: "KwaZulu Natal" },
      { name: "Umlazi", state: "KwaZulu Natal" },
      { name: "Umtalumi (Mthwalume)", state: "KwaZulu Natal" },
      { name: "Umtentweni", state: "KwaZulu Natal" },
      { name: "Umzimkulu", state: "KwaZulu Natal" },
      { name: "Umzinto", state: "KwaZulu Natal" },
      { name: "Umzinyathi", state: "KwaZulu Natal" },
      { name: "Umzumbe", state: "KwaZulu Natal" },
      { name: "Underberg", state: "KwaZulu Natal" },
      { name: "uThukela", state: "KwaZulu Natal" },
      { name: "Uvongo", state: "KwaZulu Natal" },
      { name: "Verulam", state: "KwaZulu Natal" },
      { name: "Vryheid", state: "KwaZulu Natal" },
      { name: "Wartburg", state: "KwaZulu Natal" },
      { name: "Wasbank", state: "KwaZulu Natal" },
      { name: "Westville", state: "KwaZulu Natal" },
      { name: "Weza", state: "KwaZulu Natal" },
      { name: "Zululand", state: "KwaZulu Natal" },
      { name: "Afguns", state: "Limpopo" },
      { name: "Alldays", state: "Limpopo" },
      { name: "Ba-Phalaborwa", state: "Limpopo" },
      { name: "Bandelierkop", state: "Limpopo" },
      { name: "Bela-Bela", state: "Limpopo" },
      { name: "Bochum", state: "Limpopo" },
      { name: "Bosbokrand", state: "Limpopo" },
      { name: "Dendron", state: "Limpopo" },
      { name: "Duiwelskloof", state: "Limpopo" },
      { name: "Elim", state: "Limpopo" },
      { name: "Ellisras", state: "Limpopo" },
      { name: "Gravelotte", state: "Limpopo" },
      { name: "Haenertsburg", state: "Limpopo" },
      { name: "Hoedspruit", state: "Limpopo" },
      { name: "Jane furse", state: "Limpopo" },
      { name: "Klaserie", state: "Limpopo" },
      { name: "Lebowakgomo", state: "Limpopo" },
      { name: "Lephalale", state: "Limpopo" },
      { name: "Letsitele", state: "Limpopo" },
      { name: "Leydsdorp", state: "Limpopo" },
      { name: "Louis Trichardt", state: "Limpopo" },
      { name: "Messina", state: "Limpopo" },
      { name: "Modimolle", state: "Limpopo" },
      { name: "Modjadjiskloof", state: "Limpopo" },
      { name: "Mogwadi", state: "Limpopo" },
      { name: "Mokopane", state: "Limpopo" },
      { name: "Mokopane", state: "Limpopo" },
      { name: "Mookgophong", state: "Limpopo" },
      { name: "Musina", state: "Limpopo" },
      { name: "Naboomspruit", state: "Limpopo" },
      { name: "Nylstroom", state: "Limpopo" },
      { name: "Ofcolaco", state: "Limpopo" },
      { name: "Phalaborwa", state: "Limpopo" },
      { name: "Polokwane", state: "Limpopo" },
      { name: "Roedtan", state: "Limpopo" },
      { name: "Sekgopo", state: "Limpopo" },
      { name: "Senwabarwana", state: "Limpopo" },
      { name: "Seshego", state: "Limpopo" },
      { name: "Thabazimbi", state: "Limpopo" },
      { name: "Thohoyandou", state: "Limpopo" },
      { name: "Tzaneen", state: "Limpopo" },
      { name: "Vaalwater", state: "Limpopo" },
      { name: "Vivo", state: "Limpopo" },
      { name: "Zebedeila", state: "Limpopo" },
      { name: "Zion City Moria", state: "Limpopo" },
      { name: "Aankoms", state: "Mpumalanga" },
      { name: "Acornhoek", state: "Mpumalanga" },
      { name: "Amersfoort", state: "Mpumalanga" },
      { name: "Amsterdam (eMvelo)", state: "Mpumalanga" },
      { name: "Anysspruit", state: "Mpumalanga" },
      { name: "Argent", state: "Mpumalanga" },
      { name: "Avoca", state: "Mpumalanga" },
      { name: "Avontuur", state: "Mpumalanga" },
      { name: "Badplaas (eManzana)", state: "Mpumalanga" },
      { name: "Balfour", state: "Mpumalanga" },
      { name: "Balmoral", state: "Mpumalanga" },
      { name: "Bankkop", state: "Mpumalanga" },
      { name: "Barberton", state: "Mpumalanga" },
      { name: "Belfast", state: "Mpumalanga" },
      { name: "Berbice", state: "Mpumalanga" },
      { name: "Bethal", state: "Mpumalanga" },
      { name: "Bettiesdam", state: "Mpumalanga" },
      { name: "Branddraai", state: "Mpumalanga" },
      { name: "Braunschweig", state: "Mpumalanga" },
      { name: "Breyten", state: "Mpumalanga" },
      { name: "Brondal", state: "Mpumalanga" },
      { name: "Bushbuckridge", state: "Mpumalanga" },
      { name: "Carolina", state: "Mpumalanga" },
      { name: "Chrissiesmeer", state: "Mpumalanga" },
      { name: "Davale", state: "Mpumalanga" },
      { name: "Delmas", state: "Mpumalanga" },
      { name: "Diepdale", state: "Mpumalanga" },
      { name: "Diepgezet", state: "Mpumalanga" },
      { name: "Dullstroom", state: "Mpumalanga" },
      { name: "Dundonald", state: "Mpumalanga" },
      { name: "Eerstehoek", state: "Mpumalanga" },
      { name: "Ekulindeni", state: "Mpumalanga" },
      { name: "Elukwatini", state: "Mpumalanga" },
      { name: "Embhuleni", state: "Mpumalanga" },
      { name: "Emphuluzi", state: "Mpumalanga" },
      { name: "Enkhaba", state: "Mpumalanga" },
      { name: "Ermelo", state: "Mpumalanga" },
      { name: "Fernie", state: "Mpumalanga" },
      { name: "Glenmore", state: "Mpumalanga" },
      { name: "Graskop", state: "Mpumalanga" },
      { name: "Greylingstad (Nthorwane)", state: "Mpumalanga" },
      { name: "Hartebeeskop", state: "Mpumalanga" },
      { name: "Hazyview", state: "Mpumalanga" },
      { name: "Hectorspruit (Emjejane)", state: "Mpumalanga" },
      { name: "Kaapmuiden", state: "Mpumalanga" },
      { name: "Kinross", state: "Mpumalanga" },
      { name: "Komatipoort", state: "Mpumalanga" },
      { name: "KwaMhlanga", state: "Mpumalanga" },
      { name: "Lochiel", state: "Mpumalanga" },
      { name: "Loopspruit", state: "Mpumalanga" },
      { name: "Lydenburg (Mashishing)", state: "Mpumalanga" },
      { name: "Machadodorp (eNotkozweni)", state: "Mpumalanga" },
      { name: "Malelane (Malalane)", state: "Mpumalanga" },
      { name: "Mbhejeka", state: "Mpumalanga" },
      { name: "Middelburg", state: "Mpumalanga" },
      { name: "Moddergat", state: "Mpumalanga" },
      { name: "Nelspruit (Mbombela)", state: "Mpumalanga" },
      { name: "Ngodwana", state: "Mpumalanga" },
      { name: "Ohrigstad", state: "Mpumalanga" },
      { name: "Perdekop", state: "Mpumalanga" },
      { name: "Piet Retief (eMkhondo)", state: "Mpumalanga" },
      { name: "Pilgrim's Rest", state: "Mpumalanga" },
      { name: "Sabie", state: "Mpumalanga" },
      { name: "Secunda", state: "Mpumalanga" },
      { name: "Siyabuswa", state: "Mpumalanga" },
      { name: "Skukuza", state: "Mpumalanga" },
      { name: "Standerton", state: "Mpumalanga" },
      { name: "Trichardt", state: "Mpumalanga" },
      { name: "Vaalbank", state: "Mpumalanga" },
      { name: "Volksrust", state: "Mpumalanga" },
      { name: "Wakkerstroom", state: "Mpumalanga" },
      { name: "Waterval Boven (Emgwenya)", state: "Mpumalanga" },
      { name: "Waterval Onder", state: "Mpumalanga" },
      { name: "White River", state: "Mpumalanga" },
      { name: "Witbank (eMalahleni)", state: "Mpumalanga" },
      { name: "Aggeneys", state: "Northern Cape" },
      { name: "Alexander Bay", state: "Northern Cape" },
      { name: "Andriesvale", state: "Northern Cape" },
      { name: "Askham", state: "Northern Cape" },
      { name: "Augrabies", state: "Northern Cape" },
      { name: "Barkly West", state: "Northern Cape" },
      { name: "Britstown", state: "Northern Cape" },
      { name: "Campbell", state: "Northern Cape" },
      { name: "Carolusberg", state: "Northern Cape" },
      { name: "Colesberg", state: "Northern Cape" },
      { name: "Concordia", state: "Northern Cape" },
      { name: "Copperton", state: "Northern Cape" },
      { name: "Danielskuil", state: "Northern Cape" },
      { name: "De Aar", state: "Northern Cape" },
      { name: "Delportshoop", state: "Northern Cape" },
      { name: "Douglas", state: "Northern Cape" },
      { name: "Garies", state: "Northern Cape" },
      { name: "Green Kalahari", state: "Northern Cape" },
      { name: "Griquatown", state: "Northern Cape" },
      { name: "Groblershoop", state: "Northern Cape" },
      { name: "Hanover", state: "Northern Cape" },
      { name: "Hartswater", state: "Northern Cape" },
      { name: "Hondeklip", state: "Northern Cape" },
      { name: "Hopetown", state: "Northern Cape" },
      { name: "Hutchinson", state: "Northern Cape" },
      { name: "Jan Kempdorp", state: "Northern Cape" },
      { name: "Kakamas", state: "Northern Cape" },
      { name: "Kamieskroon", state: "Northern Cape" },
      { name: "Kanoneiland", state: "Northern Cape" },
      { name: "Kathu", state: "Northern Cape" },
      { name: "Keimoes", state: "Northern Cape" },
      { name: "Kenhardt", state: "Northern Cape" },
      { name: "Kimberley", state: "Northern Cape" },
      { name: "Kleinzee", state: "Northern Cape" },
      { name: "Kuruman", state: "Northern Cape" },
      { name: "Lime Acres", state: "Northern Cape" },
      { name: "Louisvale", state: "Northern Cape" },
      { name: "Loxton", state: "Northern Cape" },
      { name: "Marydale", state: "Northern Cape" },
      { name: "Mier", state: "Northern Cape" },
      { name: "Modder River", state: "Northern Cape" },
      { name: "Nababeep", state: "Northern Cape" },
      { name: "Namaqualand", state: "Northern Cape" },
      { name: "Nieuwoudtville", state: "Northern Cape" },
      { name: "Norvalspont", state: "Northern Cape" },
      { name: "Noupoort", state: "Northern Cape" },
      { name: "Okiep", state: "Northern Cape" },
      { name: "Olifantshoek", state: "Northern Cape" },
      { name: "Onseepkans", state: "Northern Cape" },
      { name: "Orania", state: "Northern Cape" },
      { name: "Pella", state: "Northern Cape" },
      { name: "Petrusville", state: "Northern Cape" },
      { name: "Philipstown", state: "Northern Cape" },
      { name: "Pofadder", state: "Northern Cape" },
      { name: "Port Nolloth", state: "Northern Cape" },
      { name: "Postmasburg", state: "Northern Cape" },
      { name: "Prieska", state: "Northern Cape" },
      { name: "Putsonderwater", state: "Northern Cape" },
      { name: "Richmond", state: "Northern Cape" },
      { name: "Riemvasmaak", state: "Northern Cape" },
      { name: "Rietfontein", state: "Northern Cape" },
      { name: "Soebatsfontein", state: "Northern Cape" },
      { name: "Springbok", state: "Northern Cape" },
      { name: "Steinkopf", state: "Northern Cape" },
      { name: "Strydenburg", state: "Northern Cape" },
      { name: "Ulco", state: "Northern Cape" },
      { name: "Upington", state: "Northern Cape" },
      { name: "Upper Karoo", state: "Northern Cape" },
      { name: "Vanderkloof", state: "Northern Cape" },
      { name: "Victoria West", state: "Northern Cape" },
      { name: "Vosburg", state: "Northern Cape" },
      { name: "Warrenton", state: "Northern Cape" },
      { name: "Windsorton", state: "Northern Cape" },
      { name: "Amalia", state: "North West" },
      { name: "Babelegi", state: "North West" },
      { name: "Beestekraal", state: "North West" },
      { name: "Biesiesvlei", state: "North West" },
      { name: "Bloemhof", state: "North West" },
      { name: "Bray", state: "North West" },
      { name: "Brits", state: "North West" },
      { name: "Broederstroom", state: "North West" },
      { name: "Christiana", state: "North West" },
      { name: "Coligny", state: "North West" },
      { name: "Delareyville", state: "North West" },
      { name: "Derby", state: "North West" },
      { name: "Ganyesa", state: "North West" },
      { name: "Ganyesa", state: "North West" },
      { name: "Groot Marico", state: "North West" },
      { name: "Hartbeesfontein (Lethabong)", state: "North West" },
      { name: "Hartbeespoort", state: "North West" },
      { name: "Hekpoort", state: "North West" },
      { name: "Itsoseng", state: "North West" },
      { name: "Jericho", state: "North West" },
      { name: "Klerksdorp", state: "North West" },
      { name: "Kosmos", state: "North West" },
      { name: "Koster", state: "North West" },
      { name: "Kroondal", state: "North West" },
      { name: "Leeudoringstad", state: "North West" },
      { name: "Legogolwe", state: "North West" },
      { name: "Lichtenburg", state: "North West" },
      { name: "Maanhaarrand", state: "North West" },
      { name: "Mafeking (Mahikeng)", state: "North West" },
      { name: "Makwassie", state: "North West" },
      { name: "Manamakgoteng", state: "North West" },
      { name: "Mareetsane", state: "North West" },
      { name: "Mareetsane", state: "North West" },
      { name: "Mathibestad", state: "North West" },
      { name: "Mmabatho", state: "North West" },
      { name: "Mmakau", state: "North West" },
      { name: "Mogwase", state: "North West" },
      { name: "Mononono", state: "North West" },
      { name: "Mooinooi", state: "North West" },
      { name: "Morokweng", state: "North West" },
      { name: "Motlhabeng", state: "North West" },
      { name: "Orkney", state: "North West" },
      { name: "Ottosdal", state: "North West" },
      { name: "Ottoshoop", state: "North West" },
      { name: "Potchefstroom", state: "North West" },
      { name: "Ramokokastad", state: "North West" },
      { name: "Reivilo", state: "North West" },
      { name: "Rooikoppies (Marikana)", state: "North West" },
      { name: "Rustenburg", state: "North West" },
      { name: "Sannieshof", state: "North West" },
      { name: "Schweizer-Reneke", state: "North West" },
      { name: "Setlagole", state: "North West" },
      { name: "Setlopo", state: "North West" },
      { name: "Skeerpoort", state: "North West" },
      { name: "Stella", state: "North West" },
      { name: "Stilfontein", state: "North West" },
      { name: "Swartruggens", state: "North West" },
      { name: "Taung", state: "North West" },
      { name: "Tosca", state: "North West" },
      { name: "Tsitsing", state: "North West" },
      { name: "Ventersdorp", state: "North West" },
      { name: "Vryburg", state: "North West" },
      { name: "Welbedacht (Lehurutshe)", state: "North West" },
      { name: "Wolmaransstad", state: "North West" },
      { name: "Zeerust", state: "North West" },
      { name: "Albertinia", state: "Western Cape" },
      { name: "Arniston", state: "Western Cape" },
      { name: "Ashton", state: "Western Cape" },
      { name: "Atlantis", state: "Western Cape" },
      { name: "Aurora", state: "Western Cape" },
      { name: "Baardskeerdersbos", state: "Western Cape" },
      { name: "Barrydale", state: "Western Cape" },
      { name: "Beaufort West", state: "Western Cape" },
      { name: "Bellville", state: "Western Cape" },
      { name: "Betty's Bay", state: "Western Cape" },
      { name: "Birkenhead", state: "Western Cape" },
      { name: "Bitterfontein", state: "Western Cape" },
      { name: "Blue Downs", state: "Western Cape" },
      { name: "Boggomsbaai", state: "Western Cape" },
      { name: "Bonnievale", state: "Western Cape" },
      { name: "Botrivier", state: "Western Cape" },
      { name: "Brackenfell", state: "Western Cape" },
      { name: "Bredasdorp", state: "Western Cape" },
      { name: "Brenton-on-Sea", state: "Western Cape" },
      { name: "Buffelsbaai", state: "Western Cape" },
      { name: "Caledon", state: "Western Cape" },
      { name: "Calitzdorp", state: "Western Cape" },
      { name: "Cape Town", state: "Western Cape" },
      { name: "Cape Winelands", state: "Western Cape" },
      { name: "Central Karoo", state: "Western Cape" },
      { name: "Ceres", state: "Western Cape" },
      { name: "Chatsworth", state: "Western Cape" },
      { name: "Citrusdal", state: "Western Cape" },
      { name: "Clanwilliam", state: "Western Cape" },
      { name: "Crossroads", state: "Western Cape" },
      { name: "Dana Baai", state: "Western Cape" },
      { name: "Darling", state: "Western Cape" },
      { name: "De Doorns", state: "Western Cape" },
      { name: "De Kelders", state: "Western Cape" },
      { name: "De Rust", state: "Western Cape" },
      { name: "Denneburg", state: "Western Cape" },
      { name: "Dennehof", state: "Western Cape" },
      { name: "Doringbaai", state: "Western Cape" },
      { name: "Durbanville", state: "Western Cape" },
      { name: "Dwarskersbos", state: "Western Cape" },
      { name: "Dysselsdorp", state: "Western Cape" },
      { name: "Ebenhaeser", state: "Western Cape" },
      { name: "Eendekuil", state: "Western Cape" },
      { name: "Eerste River", state: "Western Cape" },
      { name: "Elands Bay", state: "Western Cape" },
      { name: "Elgin", state: "Western Cape" },
      { name: "Elim", state: "Western Cape" },
      { name: "Elsie's River", state: "Western Cape" },
      { name: "Fish Hoek", state: "Western Cape" },
      { name: "Fisherhaven", state: "Western Cape" },
      { name: "Franschhoek", state: "Western Cape" },
      { name: "Franskraalstrand", state: "Western Cape" },
      { name: "Friemersheim", state: "Western Cape" },
      { name: "Gansbaai", state: "Western Cape" },
      { name: "Garden Route", state: "Western Cape" },
      { name: "Genadendal", state: "Western Cape" },
      { name: "George", state: "Western Cape" },
      { name: "Glentana", state: "Western Cape" },
      { name: "Goedverwacht", state: "Western Cape" },
      { name: "Goodwood", state: "Western Cape" },
      { name: "Gordon's Bay", state: "Western Cape" },
      { name: "Gouda", state: "Western Cape" },
      { name: "Gouritsmond", state: "Western Cape" },
      { name: "Graafwater", state: "Western Cape" },
      { name: "Grabouw", state: "Western Cape" },
      { name: "Great Brak River", state: "Western Cape" },
      { name: "Greyton", state: "Western Cape" },
      { name: "Groot-Jongensfontein", state: "Western Cape" },
      { name: "Grotto Bay", state: "Western Cape" },
      { name: "Guguletu", state: "Western Cape" },
      { name: "Haarlem", state: "Western Cape" },
      { name: "Hartenbos", state: "Western Cape" },
      { name: "Hawston", state: "Western Cape" },
      { name: "Heidelberg", state: "Western Cape" },
      { name: "Herbertsdale", state: "Western Cape" },
      { name: "Hermanus", state: "Western Cape" },
      { name: "Herolds Bay", state: "Western Cape" },
      { name: "Hopefield", state: "Western Cape" },
      { name: "Hotagterklip", state: "Western Cape" },
      { name: "Hout Bay", state: "Western Cape" },
      { name: "Infanta", state: "Western Cape" },
      { name: "Jacobsbaai", state: "Western Cape" },
      { name: "Jakkalsfontein", state: "Western Cape" },
      { name: "Kalbaskraal", state: "Western Cape" },
      { name: "Kayamandi", state: "Western Cape" },
      { name: "Keurboomsrivier", state: "Western Cape" },
      { name: "Keurboomstrand", state: "Western Cape" },
      { name: "Khayelitsha", state: "Western Cape" },
      { name: "Klapmuts", state: "Western Cape" },
      { name: "Klawer", state: "Western Cape" },
      { name: "Klein Karoo", state: "Western Cape" },
      { name: "Kleinbaai", state: "Western Cape" },
      { name: "Kleinmond", state: "Western Cape" },
      { name: "Knysna", state: "Western Cape" },
      { name: "Koekenaap", state: "Western Cape" },
      { name: "Koringberg", state: "Western Cape" },
      { name: "Kraaifontein", state: "Western Cape" },
      { name: "Kranshoek", state: "Western Cape" },
      { name: "Kuils River", state: "Western Cape" },
      { name: "Kurland Estate", state: "Western Cape" },
      { name: "Kylemore", state: "Western Cape" },
      { name: "L'Agulhas", state: "Western Cape" },
      { name: "Ladismith", state: "Western Cape" },
      { name: "Laingsburg", state: "Western Cape" },
      { name: "Lamberts Bay", state: "Western Cape" },
      { name: "Langa", state: "Western Cape" },
      { name: "Langebaan", state: "Western Cape" },
      { name: "Langebaanweg", state: "Western Cape" },
      { name: "Languedoc", state: "Western Cape" },
      { name: "Leeu-Gamka", state: "Western Cape" },
      { name: "Little Brak River", state: "Western Cape" },
      { name: "Lutzville", state: "Western Cape" },
      { name: "Macassar", state: "Western Cape" },
      { name: "Malmesbury", state: "Western Cape" },
      { name: "Matjiesfontein", state: "Western Cape" },
      { name: "McGregor", state: "Western Cape" },
      { name: "Melkbosstrand", state: "Western Cape" },
      { name: "Merweville", state: "Western Cape" },
      { name: "Mfuleni", state: "Western Cape" },
      { name: "Milnerton", state: "Western Cape" },
      { name: "Mitchell's Plain", state: "Western Cape" },
      { name: "Montagu", state: "Western Cape" },
      { name: "Montagu", state: "Western Cape" },
      { name: "Moorreesburg", state: "Western Cape" },
      { name: "Mossel Bay", state: "Western Cape" },
      { name: "Murraysburg", state: "Western Cape" },
      { name: "Napier", state: "Western Cape" },
      { name: "Nature's Valley", state: "Western Cape" },
      { name: "Nelspoort", state: "Western Cape" },
      { name: "Noetzie", state: "Western Cape" },
      { name: "Noordhoek", state: "Western Cape" },
      { name: "Nyanga", state: "Western Cape" },
      { name: "Observatory", state: "Western Cape" },
      { name: "Onrusrivier", state: "Western Cape" },
      { name: "Op-die-Berg", state: "Western Cape" },
      { name: "Oudtshoorn", state: "Western Cape" },
      { name: "Overberg", state: "Western Cape" },
      { name: "Paarl", state: "Western Cape" },
      { name: "Pacaltsdorp", state: "Western Cape" },
      { name: "Parow", state: "Western Cape" },
      { name: "Paternoster", state: "Western Cape" },
      { name: "Pearly Beach", state: "Western Cape" },
      { name: "Piketberg", state: "Western Cape" },
      { name: "Plettenberg Bay", state: "Western Cape" },
      { name: "Pniel", state: "Western Cape" },
      { name: "Port Beaufort", state: "Western Cape" },
      { name: "Porterville", state: "Western Cape" },
      { name: "Prince Albert", state: "Western Cape" },
      { name: "Prince Alfred Hamlet", state: "Western Cape" },
      { name: "Pringle Bay", state: "Western Cape" },
      { name: "Rawsonville", state: "Western Cape" },
      { name: "Redelinghuys", state: "Western Cape" },
      { name: "Rheenendal", state: "Western Cape" },
      { name: "Riebeek West", state: "Western Cape" },
      { name: "Riebeek-Kasteel", state: "Western Cape" },
      { name: "Riversdale", state: "Western Cape" },
      { name: "Riviersonderend", state: "Western Cape" },
      { name: "Robertson", state: "Western Cape" },
      { name: "Robertsvlei", state: "Western Cape" },
      { name: "Rooi Els", state: "Western Cape" },
      { name: "Rozendal", state: "Western Cape" },
      { name: "Saldanha", state: "Western Cape" },
      { name: "Saron", state: "Western Cape" },
      { name: "Sedgefield", state: "Western Cape" },
      { name: "Simon's Town", state: "Western Cape" },
      { name: "Slangrivier", state: "Western Cape" },
      { name: "Somerset West", state: "Western Cape" },
      { name: "St Helena Bay", state: "Western Cape" },
      { name: "Stanford", state: "Western Cape" },
      { name: "Stellenbosch", state: "Western Cape" },
      { name: "Stilbaai", state: "Western Cape" },
      { name: "Strand", state: "Western Cape" },
      { name: "Strandfontein", state: "Western Cape" },
      { name: "Struisbaai", state: "Western Cape" },
      { name: "Suiderstrand", state: "Western Cape" },
      { name: "Suurbraak", state: "Western Cape" },
      { name: "Swellendam", state: "Western Cape" },
      { name: "Touws River", state: "Western Cape" },
      { name: "Tulbagh", state: "Western Cape" },
      { name: "Uniondale", state: "Western Cape" },
      { name: "Van Dyksbaai", state: "Western Cape" },
      { name: "Vanrhynsdorp", state: "Western Cape" },
      { name: "Velddrif", state: "Western Cape" },
      { name: "Vermont", state: "Western Cape" },
      { name: "Victoria Bay", state: "Western Cape" },
      { name: "Villiersdorp", state: "Western Cape" },
      { name: "Volmoed", state: "Western Cape" },
      { name: "Vredenburg", state: "Western Cape" },
      { name: "Vredendal", state: "Western Cape" },
      { name: "Wellington", state: "Western Cape" },
      { name: "Wemmershoek", state: "Western Cape" },
      { name: "West Coast", state: "Western Cape" },
      { name: "Wilderness", state: "Western Cape" },
      { name: "Wittedrift", state: "Western Cape" },
      { name: "Wolseley", state: "Western Cape" },
      { name: "Worcester", state: "Western Cape" },
      { name: "Wupperthal", state: "Western Cape" },
      { name: "Yzerfontein", state: "Western Cape" },
      { name: "Zoar", state: "Western Cape" },
    ],
  },
  ZM: {
    // TODO: get the actual codes
    states: [
      { name: "Central", code: "ZM-02", minZip: 0, maxZip: 999999 },
      { name: "Copperbelt", code: "ZM-08", minZip: 0, maxZip: 999999 },
      { name: "Eastern", code: "ZM-03", minZip: 0, maxZip: 999999 },
      { name: "Luapula", code: "ZM-04", minZip: 0, maxZip: 999999 },
      { name: "Lusaka", code: "ZM-09", minZip: 0, maxZip: 999999 },
      { name: "Northern", code: "ZM-05", minZip: 0, maxZip: 999999 },
      { name: "North-Western", code: "ZM-06", minZip: 0, maxZip: 999999 },
      { name: "Southern", code: "ZM-07", minZip: 0, maxZip: 999999 },
      { name: "Western", code: "ZM-01", minZip: 0, maxZip: 999999 },
      { name: "Muchinga", code: "ZM-10", minZip: 0, maxZip: 999999 },
    ],
    cities: [],
  },
};
